// 环保管家首页
<template>
  <div class="ehsmapwrap" id="ehsmapwrap">
    <div class="ehsRollingTitle">
      <div class="r-block">
        <div class="r-text1">区域环保管家竭诚为您服务&nbsp;&nbsp;&nbsp;</div>
        <div class="r-text2">区域环保管家竭诚为您服务&nbsp;&nbsp;&nbsp;</div>
      </div>
    </div>
    <div class="container">
      <div class="subcon">
        <div class="asideL">
          <div class="hp2divspie">
            <div class="piesubdivs" v-show="homeTypeTab == 'atmos'">
              <div class="piesubdivsheader"><b>大气主要污染物比例</b></div>
              <highcharts class="part2charts" :options="showChart211a"></highcharts>
            </div>
            <div class="piesubdivs" v-show="homeTypeTab == 'water'">
              <div class="piesubdivsheader"><b>水质主要污染物比例</b></div>
              <highcharts class="part2charts" :options="showChart211w"></highcharts>
            </div>
          </div>
          <div class="hpEqmChartDiv">
            <div class="eqmChartItems" v-show="homeTypeTab == 'atmos'">
              <div v-if="eqmAtmosAverage === 'hour'" class="eqmChartItemsheader" @click="eqmAtmosAverage = 'hours24', getEQMAtmos()"><b>{{ eqmOnlineName }}主要污染物(1h)<small>(μg/m3)</small></b></div>
              <div v-if="eqmAtmosAverage === 'hours24'" class="eqmChartItemsheader" @click="eqmAtmosAverage = 'hour', getEQMAtmos()"><b>{{ eqmOnlineName }}主要污染物(24h)<small>(μg/m3)</small></b></div>
              <highcharts class="part2charts" :options="showChartItemsa"></highcharts>
            </div>
            <div class="eqmChartItems" v-show="homeTypeTab == 'water'">
              <div class="eqmChartItemsheader"><b>{{ eqmOnlineName }}主要污染物</b></div>
              <highcharts class="part2charts" :options="showChartItemsw"></highcharts>
            </div>
          </div>
        </div>
        <div class="mainDiv">
          <div class="headerhtt">
            <div class="httTab">
              <el-tabs v-model="homeTypeTab" style="margin-right: 10px, margin-bottom: 0" @tab-click="addGraphics('stations')" stretch>
                <el-tab-pane label="  大气  " name="atmos"></el-tab-pane>
                <el-tab-pane label="  水质  " name="water"></el-tab-pane>
              </el-tabs>
            </div>
          </div>
          <div class="mainMap">
            <div class="arcgis-map-div" id="arcgisMapDiv">
              <div class="arcgis-map" id="mapView"></div>
              <div class="arcgis-timeslider" id="timeSliderView"></div>
            </div>
          </div>
        </div>
        <div class="asideR">
          <div class="hpMntDiv">
            <div class="hpMntDivHeader"><b>{{ eqmOnlineName }}监控</b></div>
            <div class="markerVideoPlayer">
              <video v-if="eqmMntUrl" class="myMntVideo" id="mntVideo" autoplay muted></video>
              <div v-else class="myMntVideoUdf">
                <i class="el-icon-warning"></i> 缺少监控地址
              </div>
            </div>
          </div>
          <div class="hpCpmInfoList bc">
            <div class="hpCpnInfoHead">
              <div class="hpCpnInfoHeadName"><b>企业名称</b></div>
              <div class="hpCpnInfoHeadIdVal"><b>信用分</b></div>
            </div>
            <div class="hpCpnInfoMain" id="hpSLt5Box">
              <div class="hpCpnInfoItem cpnStripes"
                v-for="(cpnInfoData, index) in cpnInfoDatas" :key="index">
                <div class="hpCpnInfoData">
                  <div class="hpCpnInfoName">{{ cpnInfoData.cpnName }}</div>
                  <div class="hpCpnInfoIdVal">{{ cpnInfoData.accptCclsn }}</div>
                </div>
              </div>
              <div v-if="hpSLt5BoxShowF">
                <div class="hpCpnInfoItem cpnStripes"
                  v-for="(cpnInfoData, index) in cpnInfoDatas" :key="index">
                  <div class="hpCpnInfoData">
                    <div class="hpCpnInfoName">{{ cpnInfoData.cpnName }}</div>
                    <div class="hpCpnInfoIdVal">{{ cpnInfoData.accptCclsn }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="footersites">
        <div class="hpSiteListDivs">
          <div class="t1subdivs" v-show="homeTypeTab == 'atmos'">
            <div class="t1subdivsheader"><b>良好大气主要污染物浓度</b><small>(μg/m3)</small></div>
            <highcharts class="t1charts" :options="showChartT2Bara"></highcharts>
          </div>
          <div class="t1subdivs" v-show="homeTypeTab == 'water'">
            <div class="t1subdivsheader"><b>良好水质主要污染物浓度</b><small>(mg/L)</small></div>
            <highcharts class="t1charts" :options="showChartT2Barw"></highcharts>
          </div>
        </div>
        <div class="hpSiteListDivs">
          <div class="hpSiteListCard t2bc">
            <div class="hpSiteListHead" id="hpSLHT2">
              <div class="hpSiteListhdiv" v-show="homeTypeTab == 'atmos'"><b>正常大气主要污染物站点列表</b></div>
              <div class="hpSiteListhdiv" v-show="homeTypeTab == 'water'"><b>正常水质主要污染物站点列表</b></div>
            </div>
            <div class="hpSiteListMain" id="hpSLt2Box">
              <div class="hpSiteListItem t2Stripes anm-1"
                v-for="(siteT2Datas, index) in chartsDatas[homeTypeTab].siteT2Datas"
                :key="index">
                <div class="hpSiteListData">
                  <div class="hpSiteListName">{{ siteT2Datas.itemSite }}</div>
                  <div class="hpSiteListIdVal">{{ siteT2Datas.itemId }} {{ siteT2Datas.itemValue }}{{ siteT2Datas.itemUnit }}</div>
                </div>
              </div>
              <div v-if="hpSLt2BoxShowF">
                <div class="hpSiteListItem t2Stripes anm-2"
                  v-for="(siteT2Datas, index) in chartsDatas[homeTypeTab].siteT2Datas"
                  :key="index + 'a2'">
                  <div class="hpSiteListData">
                    <div class="hpSiteListName">{{ siteT2Datas.itemSite }}</div>
                    <div class="hpSiteListIdVal">{{ siteT2Datas.itemId }} {{ siteT2Datas.itemValue }}{{ siteT2Datas.itemUnit }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="hpSiteListDivs">
          <div class="hpSiteListCard t3bc">
            <div slot="header">
              <div class="hpSiteListHead" id="hpSLHT3">
                <div class="hpSiteListhdiv" v-show="homeTypeTab == 'atmos'"><b>预警大气主要污染物站点列表</b></div>
                <div class="hpSiteListhdiv" v-show="homeTypeTab == 'water'"><b>预警水质主要污染物站点列表</b></div>
              </div>
            </div>
            <div class="hpSiteListMain" id="hpSLt3Box">
              <div class="hpSiteListItem t3Stripes anm-1"
                v-for="(siteT3Datas, index) in chartsDatas[homeTypeTab].siteT3Datas"
                :key="index">
                <div class="hpSiteListData">
                  <div class="hpSiteListName">{{ siteT3Datas.itemSite }}</div>
                  <div class="hpSiteListIdVal">{{ siteT3Datas.itemId }} {{ siteT3Datas.itemValue }}{{ siteT3Datas.itemUnit }}</div>
                </div>
              </div>
              <div v-if="hpSLt3BoxShowF">
                <div class="hpSiteListItem t3Stripes anm-2"
                  v-for="(siteT3Datas, index) in chartsDatas[homeTypeTab].siteT3Datas"
                  :key="index + 'a2'">
                  <div class="hpSiteListData">
                    <div class="hpSiteListName">{{ siteT3Datas.itemSite }}</div>
                    <div class="hpSiteListIdVal">{{ siteT3Datas.itemId }} {{ siteT3Datas.itemValue }}{{ siteT3Datas.itemUnit }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="hpSiteListDivs">
          <div class="hpSiteListCard t4bc">
            <div slot="header">
              <div class="hpSiteListHead" id="hpSLHT4">
                <div class="hpSiteListhdiv" v-show="homeTypeTab == 'atmos'"><b>超标大气主要污染物站点列表</b></div>
                <div class="hpSiteListhdiv" v-show="homeTypeTab == 'water'"><b>超标水质主要污染物站点列表</b></div>
              </div>
            </div>
            <div class="hpSiteListMain" id="hpSLt4Box">
              <div class="hpSiteListItem t4Stripes anm-1"
                v-for="(siteT4Datas, index) in chartsDatas[homeTypeTab].siteT4Datas"
                :key="index">
                <div class="hpSiteListData">
                  <div class="hpSiteListName">{{ siteT4Datas.itemSite }}</div>
                  <div class="hpSiteListIdVal">{{ siteT4Datas.itemId }} {{ siteT4Datas.itemValue }}{{ siteT4Datas.itemUnit }}</div>
                </div>
              </div>
              <div v-if="hpSLt4BoxShowF">
                <div class="hpSiteListItem t4Stripes anm-2"
                  v-for="(siteT4Datas, index) in chartsDatas[homeTypeTab].siteT4Datas"
                  :key="index + 'a2'">
                  <div class="hpSiteListData">
                    <div class="hpSiteListName">{{ siteT4Datas.itemSite }}</div>
                    <div class="hpSiteListIdVal">{{ siteT4Datas.itemId }} {{ siteT4Datas.itemValue }}{{ siteT4Datas.itemUnit }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="measurementBar" id="topbarMeasure">
      <button
        class="action-button esri-icon-measure-line"
        id="distanceButton"
        type="button"
        title="测距离"
      ></button><br>
      <button
        class="action-button esri-icon-measure-area"
        id="areaButton"
        type="button"
        title="测面积"
      ></button>
    </div>
    <div class="provinceList" id="provinceListBar2D">
      <select v-model="mapProvinceActive" placeholder="请选择" @change="provinceChange()">
        <option v-for="(item, index) in mapProvinceList" :key="index" :label="item" :value="item"></option>
      </select>
    </div>
    <div class="provinceList" id="provinceListBar3D">
      <select v-model="mapProvinceActive" placeholder="请选择" @change="provinceChange()">
        <option v-for="(item, index) in mapProvinceList" :key="index" :label="item" :value="item"></option>
      </select>
    </div>
    <nut-dialog
      @close="showDetailsAtmos = false"
      v-if="showDetailsAtmos"
      :visible="showDetailsAtmos"
      title="大气站点详情"
      :noFooter="true">
      <ehsEQMAtmos :markerOrder="eqmMntOrder"></ehsEQMAtmos>
    </nut-dialog>
    <nut-dialog
      @close="showDetailsWater = false"
      v-if="showDetailsWater"
      :visible="showDetailsWater"
      title="水质站点详情"
      :noFooter="true">
      <ehsEQMWater :markerOrder="eqmMntOrder" :waterClass="eqmClass"></ehsEQMWater>
    </nut-dialog>
    <nut-dialog
      @close="showObjDataSetterF = false"
      v-if="showObjDataSetterF"
      :visible="showObjDataSetterF"
      title="设置元素数据"
      :noFooter="true">
      <div style="text-align: center;">
        元素颜色：
        <input type="color" v-model="objDataSetter.colorName">；
        所属地区：
        <select v-model="mapProvinceActive">
          <option v-for="(item, index) in mapProvinceList" :key="index" :label="item" :value="item"></option>
        </select>
      </div>
      <el-button @click="createPointData()" size="medium" type="primary">确定</el-button>
    </nut-dialog>
    <nut-dialog
      :visible="showWasteFlag"
      title="基础设定"
      :closeOnClickModal="false"
      :noFooter="true">
      <div>
        <b style="color: black;">地区：</b>
        <select v-model="mapProvinceActive">
          <option v-for="(item, index) in mapProvinceList" :key="index" :label="item" :value="item"></option>
        </select>；
        <b style="color: black;">单位：</b>
        <input v-if="showCpnListFlag" v-model="mapCpnActive" placeholder="请输入单位名称">
        <select v-else v-model="mapCpnActive">
          <option v-for="(item, index) in cpnList" :key="index" :label="item" :value="item"></option>
        </select>
        <span @click="showCpnListFlag = !showCpnListFlag"> 或
          <u v-if="showCpnListFlag">选择</u>
          <u v-else>新增</u>
        </span>
      </div>
      <p>温馨提示：</p>
      <p>（1）被选择的单位将成为<b style="color: black;">环保管家</b>中所使用的<b style="color: black;">默认单位名称</b>，如排污许可执行报告、信息公开表公示等。</p>
      <p>（2）<b style="color: black;">选择或新增</b>一个单位有利于其信息同步，如选择A单位并填写完其<b style="color: black;">单位基本信息</b>后，在其他页面中<b style="color: black;">再次选择A单位</b>即可同步已填写的信息，<b style="color: black;">无需重复填写</b>。</p>
      <p>（3）被选择的地区将成为<b style="color: black;">地图功能</b>的<b style="color: black;">默认初始加载地区</b>。</p>
      <p>（4）若无法加载地图，请<b style="color: black;">刷新页面或重启浏览器</b>。</p>
      <!-- <el-form-item style="text-align: center;"> -->
      <el-button type="primary" @click="submitUnit()" size="medium" style="width: 88px; height: 36px;">确定</el-button>
      <!-- </el-form-item> -->
      <!-- </el-form> -->
    </nut-dialog>
  </div>
</template>

<script>
/* eslint-disable no-undef */
import api from '../../../api/index'
import { loadModules } from 'esri-loader'
import flvjs from 'flv.js'
// import axios from 'axios'
import mapiconblue from '../../assets/mapicons/mapiconblue.png'
import mapicongreen from '../../assets/mapicons/mapicongreen.png'
import mapiconyellow from '../../assets/mapicons/mapiconyellow.png'
import mapiconred from '../../assets/mapicons/mapiconred.png'
import mapiconblack from '../../assets/mapicons/mapiconblack.png'
import atmosiconblue from '../../assets/mapicons/atmosiconblue.png'
import atmosicongreen from '../../assets/mapicons/atmosicongreen.png'
import atmosiconyellow from '../../assets/mapicons/atmosiconyellow.png'
import atmosiconred from '../../assets/mapicons/atmosiconred.png'
import atmosiconblack from '../../assets/mapicons/atmosiconblack.png'
import watericonblue from '../../assets/mapicons/watericonblue.png'
import watericongreen from '../../assets/mapicons/watericongreen.png'
import watericonyellow from '../../assets/mapicons/watericonyellow.png'
import watericonred from '../../assets/mapicons/watericonred.png'
import watericonblack from '../../assets/mapicons/watericonblack.png'
import uelectroiconblue from '../../assets/mapicons/uelectroiconblue.png'
import uelectroicongreen from '../../assets/mapicons/uelectroicongreen.png'
import uelectroiconyellow from '../../assets/mapicons/uelectroiconyellow.png'
import uelectroiconred from '../../assets/mapicons/uelectroiconred.png'
import uelectroiconblack from '../../assets/mapicons/uelectroiconblack.png'
import uwatericonblue from '../../assets/mapicons/uwatericonblue.png'
import uwatericongreen from '../../assets/mapicons/uwatericongreen.png'
import uwatericonyellow from '../../assets/mapicons/uwatericonyellow.png'
import uwatericonred from '../../assets/mapicons/uwatericonred.png'
import uwatericonblack from '../../assets/mapicons/uwatericonblack.png'
import ehsEQMAtmos from '../ehs-com/ehsEQMAtmos'
import ehsEQMWater from '../ehs-com/ehsEQMWater'
export default {
  data () {
    return {
      showWasteFlag: true,
      showCpnListFlag: false,
      mapCpnActive: '',
      cpnList: [],
      homeTypeTab: 'atmos',
      player: null,
      color: ['#1E90FF', '#008000', '#DAA520', '#FF0000', '#b3b3b3'],
      siteType: ['良好', '正常', '预警', '超标', '默认'],
      cbtTypes: ['良 好', '正 常', '预 警', '超 标'],
      cbtid: ['cbtT1', 'cbtT2', 'cbtT3', 'cbtT4'],
      itemDataKeysAtmos: ['xa1hSO2', 'xa1hNO2', 'xa1hCO', 'xa1hO3', 'xa24hPM10', 'xa24hPM2o5'],
      itemDataKeysWater: ['xwCODMn', 'xwCOD', 'xwBOD5', 'xwNH3_H'],
      chartsDatas: {
        atmos: {
          siteBasicDatas: {
            siteT1Num: 12,
            siteT2Num: 2,
            siteT3Num: 3,
            siteT4Num: 4,
            siteTotal: 10,
            siteT1Ratio: 10,
            siteT2Ratio: 20,
            siteT3Ratio: 30,
            siteT4Ratio: 40
          },
          itemBasicDatas: {
            // pieT1Num: 0,
            // pieT2Num: 0,
            // pieT3Num: 0,
            // pieT4Num: 0,
            // pieTotal: 0,
            pieT1Ratio: 10,
            pieT2Ratio: 20,
            pieT3Ratio: 30,
            pieT4Ratio: 40
          },
          itemT4SiteDatas: [{
            xsiteName: 'site1',
            xa1hSO2: 501,
            xa1hNO2: 201,
            xa1hCO: 11,
            xa1hO3: 201,
            xa24hPM10: 151,
            xa24hPM2o5: 76
          }, {
            xsiteName: 'site2',
            xa1hSO2: 501,
            xa1hNO2: 201,
            xa1hCO: 11,
            xa1hO3: 201,
            // xa24hPM10: 151,
            xa24hPM2o5: 76
          }, {
            xsiteName: 'site2',
            xa1hSO2: 501,
            xa1hNO2: 201,
            xa1hCO: 11,
            xa1hO3: 201,
            // xa24hPM10: 151,
            xa24hPM2o5: 76
          }, {
            xsiteName: 'site3',
            xa1hSO2: 501,
            xa1hNO2: 201,
            // xa1hCO: 11,
            xa1hO3: 201,
            xa24hPM10: 151,
            xa24hPM2o5: 76
          }],
          itemMaxDatas: {
            xa1hSO2Max: 501,
            xa1hNO2Max: 201,
            xa1hCOMax: 11,
            xa1hO3Max: 201,
            xa24hPM10Max: 151,
            xa24hPM2o5Max: 76
          },
          itemT1MaxDatas: {
            xa1hSO2T1Max: 50,
            xa1hNO2T1Max: 20,
            xa1hCOT1Max: 1,
            // xa1hO3T1Max: 20,
            xa1hO3T1Max: 0,
            xa24hPM10T1Max: 15,
            xa24hPM2o5T1Max: 7.5
          },
          siteT2Datas: [
            { itemId: 'SO2(1h)', itemUnit: 'μg/m3', itemValue: 250, itemRatio: 250 / 500, itemSite: 'site1' },
            { itemId: 'SO2(1h)', itemUnit: 'μg/m3', itemValue: 250, itemRatio: 250 / 500, itemSite: 'site1' },
            { itemId: 'SO2(1h)', itemUnit: 'μg/m3', itemValue: 250, itemRatio: 250 / 500, itemSite: 'site1' },
            { itemId: 'NO2(1h)', itemUnit: 'μg/m3', itemValue: 100, itemRatio: 100 / 200, itemSite: 'site2' }
          ],
          siteT3Datas: [
            { itemId: 'SO2(1h)', itemUnit: 'μg/m3', itemValue: 500, itemRatio: 500 / 500, itemSite: 'site3' },
            { itemId: 'SO2(1h)', itemUnit: 'μg/m3', itemValue: 500, itemRatio: 500 / 500, itemSite: 'site3' },
            { itemId: 'SO2(1h)', itemUnit: 'μg/m3', itemValue: 500, itemRatio: 500 / 500, itemSite: 'site3' },
            { itemId: 'NO2(1h)', itemUnit: 'μg/m3', itemValue: 200, itemRatio: 200 / 200, itemSite: 'site4' }
          ]
        },
        water: {
          siteBasicDatas: {
            siteT1Num: 4,
            siteT2Num: 3,
            siteT3Num: 2,
            siteT4Num: 1,
            siteTotal: 10,
            siteT1Ratio: 40,
            siteT2Ratio: 30,
            siteT3Ratio: 20,
            siteT4Ratio: 10
          },
          itemBasicDatas: {
            pieT1Ratio: 40,
            pieT2Ratio: 30,
            pieT3Ratio: 20,
            pieT4Ratio: 10
          },
          itemT4SiteDatas: [{
            xsiteName: 'site1',
            xwCODMn: 7,
            xwCOD: 21,
            xwBOD5: 5,
            xwNH3_H: 2
          }, {
            xsiteName: 'site2',
            xwCODMn: 7,
            xwCOD: 21,
            xwBOD5: 5,
            xwNH3_H: 2
          }, {
            xsiteName: 'site3',
            xwCODMn: 7,
            xwCOD: 21,
            xwBOD5: 5,
            xwNH3_H: 2
          }],
          itemMaxDatas: {
            xwCODMnMax: 7,
            xwCODMax: 21,
            xwBOD5Max: 5,
            xwNH3_HMax: 2
          },
          itemT1MaxDatas: {
            xwCODMnT1Max: 0.6,
            xwCODT1Max: 2,
            // xwBOD5T1Max: 0.4,
            xwNH3_HT1Max: 0.1
          },
          siteT2Datas: [
            { itemId: 'CODMn', itemUnit: 'mg/L', itemValue: 3, itemRatio: 3 / 6, itemSite: 'site1' },
            { itemId: 'COD', itemUnit: 'mg/L', itemValue: 10, itemRatio: 10 / 20, itemSite: 'site2' }
          ],
          siteT3Datas: [
            { itemId: 'CODMn', itemUnit: 'mg/L', itemValue: 6, itemRatio: 6 / 6, itemSite: 'site3' },
            { itemId: 'COD', itemUnit: 'mg/L', itemValue: 20, itemRatio: 20 / 20, itemSite: 'site4' }
          ]
        }
      },
      // 站点排放图
      eqmOnlineId: 0,
      eqmOnlineName: '',
      eqmAtmosAverage: 'hour', // 'hour', 'hours24'
      eqmAtmosData: [],
      eqmWaterData: [],
      eqmMntUrl: '',
      cpnInfoDatas: [],
      // 地图
      eqmMntOrder: 0,
      eqmClass: '',
      showDetailsAtmos: false,
      showDetailsWater: false,
      showObjDataSetterF: false,
      filterType: [0, 1, 2, 3, 4],
      gisAppliView: null,
      gisBackupViewParams: null,
      gisMap: null,
      gisMapView: null,
      gisScene: null,
      gisSceneView: null,
      // gisWMTSLayer: null,
      // gisWMTSLayerScene: null,
      tdtIBOLayer: null,
      tdtCIALayer: null,
      tdtCVALayer: null,
      tdtIBOLayerScene: null,
      tdtCIALayerScene: null,
      tdtCVALayerScene: null,
      gisVectorTileLayer: null,
      gisVectorTileLayerScene: null,
      gisSearch: null,
      gisSearchScene: null,
      gisSketchsLayer: null,
      gisStationsLayer: null,
      gisGraphicsLayer: null,
      gisSketch: null,
      gisTimeSlider: null,
      activeStopDate: '',
      mapProvinceActive: '北京市',
      mapProvinceList: [
        '北京市', '天津市', '河北省', '山西省', '内蒙古自治区',
        '辽宁省', '吉林省', '黑龙江省',
        '上海市', '江苏省', '浙江省', '安徽省', '福建省', '江西省', '山东省',
        '河南省', '湖北省', '湖南省', '广东省', '广西壮族自治区', '海南省',
        '四川省', '贵州省', '云南省', '西藏自治区', '重庆市',
        '陕西省', '甘肃省', '青海省', '宁夏回族自治区', '新疆维吾尔自治区'
      ],
      activeWidget: null,
      crtBaseMap: 'streets-relief-vector',
      mapLayerType: 'WMTS',
      mapLayerTypeArr: ['none', 'WMTS'],
      viewDimensionType: '2d',
      markerIconList: {
        mapicon: {
          blue: mapiconblue,
          green: mapicongreen,
          yellow: mapiconyellow,
          red: mapiconred,
          black: mapiconblack
        },
        atmosicon: {
          blue: atmosiconblue,
          green: atmosicongreen,
          yellow: atmosiconyellow,
          red: atmosiconred,
          black: atmosiconblack
        },
        watericon: {
          blue: watericonblue,
          green: watericongreen,
          yellow: watericonyellow,
          red: watericonred,
          black: watericonblack
        },
        uelectroicon: {
          blue: uelectroiconblue,
          green: uelectroicongreen,
          yellow: uelectroiconyellow,
          red: uelectroiconred,
          black: uelectroiconblack
        },
        uwatericon: {
          blue: uwatericonblue,
          green: uwatericongreen,
          yellow: uwatericonyellow,
          red: uwatericonred,
          black: uwatericonblack
        }
      },
      regularColors: { // rgb
        black: ['33', '33', '33'],
        blue: ['11', '95', 'db'],
        green: ['2a', 'a5', '15'],
        red: ['d8', '1e', '06'],
        yellow: ['ef', 'b3', '36'],
        strokeColor: ['99', '99', '99'],
        transparency: '99'
      },
      objDataSetter: {
        cPoint: [],
        colorName: '#1195db'
      },
      mapFullScreenFlag: false,
      isRefresh: true,
      chartOptionsItemsa: {},
      chartOptionsItemsw: {},
      chartOptions221a: {},
      chartOptions221w: {},
      chartOptionsT2Bar: {},
      chartOptionsT2Barw: {},
      windowClientHeight: document.body.clientHeight,
      hpSLt5BoxShowF: false,
      hpSLt2BoxShowF: false,
      hpSLt3BoxShowF: false,
      hpSLt4BoxShowF: false,
      hpSLt5BoxHeight: 0,
      hpSLt2BoxHeight: 0,
      hpSLt3BoxHeight: 0,
      hpSLt4BoxHeight: 0,
      hpSLt5BoxCcltor: null,
      hpSLt2BoxCcltor: null,
      hpSLt3BoxCcltor: null,
      hpSLt4BoxCcltor: null,
      hpSLtBoxRTI: 80,
      hpSLtBoxScrollTopI: 1,
      autoRefreshCcltr: null,
      autoRefreshRTI: 3600000,
      tdtTk: 'daf534f80a571d37738cc8e681b1e2cd'
    }
  },
  computed: {
    showChart211a: function () {
      this.chartInit('showChart211a')
      return this.chartOptions211a
    },
    showChart211w: function () {
      this.chartInit('showChart211w')
      return this.chartOptions211w
    },
    showChartItemsa: function () {
      this.chartInit('chartInitItemsa')
      return this.chartOptionsItemsa
    },
    showChartItemsw: function () {
      this.chartInit('chartInitItemsw')
      return this.chartOptionsItemsw
    },
    showChart221a: function () {
      this.chartInit('chartInit221a')
      return this.chartOptions221a
    },
    showChart221w: function () {
      this.chartInit('chartInit221w')
      return this.chartOptions221w
    },
    showChartT2Bara: function () {
      this.chartInit('chartInitT2Bara')
      return this.chartOptionsT2Bara
    },
    showChartT2Barw: function () {
      this.chartInit('chartInitT2Barw')
      return this.chartOptionsT2Barw
    }
  },
  mounted () {
    this.getUnitTable()
    window.onresize = () => {
      this.windowClientHeight = document.body.clientHeight
    }
    // var tempPR = []
    // for (var i = 0; i < this.mapProvinceList.length; i++) {
    //   tempPR.push({ text: this.mapProvinceList[i], value: this.mapProvinceList[i] })
    // }
    // this.mapProvinceList = [tempPR]
    api.appUserMapProvinceEnquiry().then(res => {
      this.mapProvinceActive = res.data
      this.autoRefresh()
      this.getHomeDatas()
      this.mapinit()
      this.getCpnInfo()
    })
  },
  methods: {
    getUnitTable () {
      api.appUserCompany({
      }).then(res => {
        console.log('appUserCompany', res)
        var tempArr = []
        res.data.forEach(item => {
          tempArr.push(item.cpnName)
        })
        this.cpnList = tempArr
      })
    },
    submitUnit () {
      this.provinceChange()
      api.appUserUpdate({
        cpnName: this.mapCpnActive
      }).then(res => {
        console.log(res)
        this.$toast.text(res.message)
        this.showWasteFlag = false
        this.addGraphics()
      })
    },
    autoRefresh () {
      this.autoRefreshCcltr = setInterval(() => {
        console.log('autoRefreshCcltr')
        this.getHomeDatas()
        this.addGraphics()
      }, this.autoRefreshRTI)
    },
    mapinit () {
      loadModules([
        'esri/Map',
        'esri/views/MapView',
        'esri/Basemap',
        'esri/views/SceneView',
        'esri/layers/WMTSLayer',
        'esri/layers/VectorTileLayer',
        'esri/layers/GraphicsLayer',
        'esri/layers/WebTileLayer',
        'esri/widgets/Compass',
        'esri/widgets/Search',
        'esri/widgets/Sketch',
        'esri/widgets/ScaleBar'
      ], { css: true }).then(([
        ArcGISMap,
        MapView,
        Basemap,
        SceneView,
        WMTSLayer,
        VectorTileLayer,
        GraphicsLayer,
        WebTileLayer,
        Compass,
        Search,
        Sketch,
        ScaleBar
      ]) => {
        this.initView(Basemap, ArcGISMap, MapView, SceneView, WebTileLayer)
        // // basemap
        // const baseMap = new Basemap({
        //   portalItem: {
        //     id: 'bc19c34549de4000bcd91cef929420dc'
        //   }
        // })
        // // 2D地图底图
        // this.gisMap = new ArcGISMap({
        //   basemap: baseMap
        // })
        // // 3D地图底图
        // this.gisScene = new ArcGISMap({
        //   basemap: 'sitellite',
        //   ground: 'world-elevation'
        // })
        // 2D地图视图对象
        this.gisMapView = new MapView({
          center: [116.391349, 39.907375],
          map: this.gisMap,
          zoom: 17
        })
        // 3D地图视图对象
        this.gisSceneView = new SceneView({
          center: [116.391349, 39.907375],
          map: this.gisScene,
          zoom: 17
        })
        // 切换2d/3d
        this.gisAppliView = {
          mapView: null,
          sceneView: null,
          activeView: null,
          container: document.getElementById('mapView')
          // container: null
        }
        this.gisBackupViewParams = {
          zoom: 17,
          center: [116.391349, 39.907375]
          // container: this.gisAppliView.document
        }
        this.gisAppliView.mapView = this.gisMapView
        this.gisAppliView.sceneView = this.gisSceneView
        this.gisAppliView.activeView = this.gisAppliView.mapView
        this.gisAppliView.activeView.container = this.gisAppliView.container
        // WMTS图层
        this.gisWMTSLayer = new WMTSLayer({
          url: 'https://wayback.maptiles.arcgis.com/arcgis/rest/services/world_imagery/wmts',
          copyright:
            '<a href="https://www.arcgis.com/index.html">Earthdata</a> by Esri',
          activeLayer: {
            id: 'SRTM_Color_Index'
          }
        })
        this.gisMap.add(this.gisWMTSLayer)
        this.gisWMTSLayerScene = new WMTSLayer({
          url: 'https://wayback.maptiles.arcgis.com/arcgis/rest/services/world_imagery/wmts',
          copyright:
            '<a href="https://www.arcgis.com/index.html">Earthdata</a> by Esri',
          activeLayer: {
            id: 'SRTM_Color_Index'
          }
        })
        this.gisScene.add(this.gisWMTSLayerScene)
        // 矢量图层 // url为eris online图层的样式地址
        // this.gisVectorTileLayer = new VectorTileLayer({
        //   title: '2d矢量图层',
        //   url: 'https://www.arcgis.com/sharing/rest/content/items/2a2e806e6e654ea78ecb705149ceae9f/resources/styles/root.json?f=pjson'
        // })
        // this.gisMap.add(this.gisVectorTileLayer)
        // console.log('gisVectorTileLayer')
        // this.gisVectorTileLayerScene = new VectorTileLayer({
        //   title: '3d矢量图层',
        //   url: 'https://www.arcgis.com/sharing/rest/content/items/2a2e806e6e654ea78ecb705149ceae9f/resources/styles/root.json?f=pjson'
        // })
        // this.gisScene.add(this.gisVectorTileLayerScene)
        // console.log('gisVectorTileLayerScene')
        // 天地图标注图层
        this.tdtIBOLayer = new WebTileLayer({ // 天地图-全球境界
          urlTemplate: 'https://{subDomain}.tianditu.gov.cn/ibo_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=ibo&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TILEMATRIX={level}&TILEROW={row}&TILECOL={col}&tk=' + this.tdtTk,
          subDomains: ['t0', 't1', 't2', 't3', 't4', 't5', 't6', 't7'],
          title: '天地图-全球境界'
        })
        this.tdtCIALayer = new WebTileLayer({ // 天地图-影像注记
          urlTemplate: 'https://{subDomain}.tianditu.gov.cn/cia_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=cia&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TILEMATRIX={level}&TILEROW={row}&TILECOL={col}&tk=' + this.tdtTk,
          subDomains: ['t0', 't1', 't2', 't3', 't4', 't5', 't6', 't7'],
          title: '天地图-影像注记'
        })
        this.tdtCVALayer = new WebTileLayer({ // 天地图-矢量注记
          urlTemplate: 'https://{subDomain}.tianditu.gov.cn/cva_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=cva&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TILEMATRIX={level}&TILEROW={row}&TILECOL={col}&tk=' + this.tdtTk,
          subDomains: ['t0', 't1', 't2', 't3', 't4', 't5', 't6', 't7'],
          title: '天地图-矢量注记'
        })
        this.tdtIBOLayerScene = new WebTileLayer({ // 3d天地图-全球境界
          urlTemplate: 'https://{subDomain}.tianditu.gov.cn/ibo_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=ibo&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TILEMATRIX={level}&TILEROW={row}&TILECOL={col}&tk=' + this.tdtTk,
          subDomains: ['t0', 't1', 't2', 't3', 't4', 't5', 't6', 't7'],
          title: '3d天地图-全球境界'
        })
        this.tdtCIALayerScene = new WebTileLayer({ // 3d天地图-影像注记
          urlTemplate: 'https://{subDomain}.tianditu.gov.cn/cia_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=cia&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TILEMATRIX={level}&TILEROW={row}&TILECOL={col}&tk=' + this.tdtTk,
          subDomains: ['t0', 't1', 't2', 't3', 't4', 't5', 't6', 't7'],
          title: '3d天地图-影像注记'
        })
        this.tdtCVALayerScene = new WebTileLayer({ // 3d天地图-矢量注记
          urlTemplate: 'https://{subDomain}.tianditu.gov.cn/cva_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=cva&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TILEMATRIX={level}&TILEROW={row}&TILECOL={col}&tk=' + this.tdtTk,
          subDomains: ['t0', 't1', 't2', 't3', 't4', 't5', 't6', 't7'],
          title: '3d天地图-矢量注记'
        })
        this.gisMap.addMany([this.tdtIBOLayer, this.tdtCIALayer, this.tdtCVALayer])
        this.gisScene.addMany([this.tdtIBOLayerScene, this.tdtCIALayerScene, this.tdtCVALayerScene])
        // 创建图层
        this.gisSketchsLayer = new GraphicsLayer({ title: '草图图层' })
        this.gisStationsLayer = new GraphicsLayer({ title: '站点图层' })
        this.gisGraphicsLayer = new GraphicsLayer({ title: '几何图层' })
        this.gisMap.addMany([this.gisGraphicsLayer, this.gisStationsLayer, this.gisSketchsLayer])
        // 3d图层
        this.gisSketchsLayerScene = new GraphicsLayer({ title: '3d草图图层' })
        this.gisStationsLayerScene = new GraphicsLayer({ title: '3d站点图层' })
        this.gisGraphicsLayerScene = new GraphicsLayer({ title: '3d几何图层' })
        this.gisGraphicsLayerSceneAux = new GraphicsLayer({ title: '3d辅助几何图层' })
        this.gisScene.addMany([this.gisGraphicsLayerSceneAux, this.gisGraphicsLayerScene, this.gisStationsLayerScene, this.gisSketchsLayerScene])
        // 2d自定义控件
        this.gisMapView.ui.add(this.setFullScreenBtn(), { position: 'top-left', index: 3 })
        this.gisMapView.ui.add(this.setSwitchMapBtn(), { position: 'top-left', index: 4 })
        this.gisMapView.ui.add(this.setSwitchOSMBtn(), { position: 'top-left', index: 5 })
        this.gisMapView.ui.add(this.setSwitchDBtn(), { position: 'top-left', index: 6 })
        this.gisMapView.ui.add(this.setShowTimeSlider(), { position: 'bottom-left', index: 0 })
        // this.gisMapView.ui.add(this.setCreateObjBtn(), { position: 'top-right', index: 2 })
        this.gisMapView.ui.add('provinceListBar2D', { position: 'bottom-right', index: 1 })
        // 3d
        this.gisSceneView.ui.add(this.setFullScreenBtn(), { position: 'top-left', index: 2 })
        this.gisSceneView.ui.add(this.setSwitchMapBtn(), { position: 'top-left', index: 3 })
        this.gisSceneView.ui.add(this.setSwitchOSMBtn(), { position: 'top-left', index: 4 })
        this.gisSceneView.ui.add(this.setSwitchDBtn(), { position: 'top-left', index: 5 })
        this.gisSceneView.ui.add(this.setShowTimeSlider(), { position: 'bottom-left', index: 0 })
        this.gisSceneView.ui.add('provinceListBar3D', { position: 'bottom-right', index: 0 })
        // 站点记录时间轴
        this.createTimeSlider(new Date())
        // 搜索
        this.gisSearch = new Search({ view: this.gisMapView })
        this.gisSearch.on('search-start', (event) => {
          this.gisMapView.popup.open({
            actions: []
          })
        })
        this.gisMapView.ui.add(this.gisSearch, { position: 'top-left', index: 0 })
        this.gisSearchScene = new Search({ view: this.gisSceneView })
        this.gisSearchScene.on('search-start', (event) => {
          this.gisSceneView.popup.open({
            actions: []
          })
        })
        this.gisSceneView.ui.add(this.gisSearchScene, { position: 'top-left', index: 0 })
        // 指南针
        const gisCompass = new Compass({
          view: this.gisMapView
        })
        this.gisMapView.ui.add(gisCompass, { position: 'top-left', index: 6 })
        // 比例尺
        var scaleBar = new ScaleBar({
          view: this.gisMapView,
          style: 'rule',
          unit: 'metric'
        })
        this.gisMapView.ui.add(scaleBar, 'bottom-right')
        // 绘图工具
        // this.gisSketch = new Sketch({
        //   layer: this.gisSketchsLayer,
        //   view: this.gisMapView,
        //   availableCreateTools: ['point', 'polygon', 'rectangle', 'circle'],
        //   creationMode: 'update'
        // })
        // this.gisMapView.ui.add(this.gisSketch, { position: 'top-right', index: 2 })
        // this.gisSketchCreateObjs(this.gisSketch, webMercatorUtils)
        // 测量
        this.gisMeasurement()
        // 添加覆盖物
        this.addGraphics()
        // init popup
        this.initPopup()
        // 点击事件
        this.initClickEvt()
      })
    },
    initView (Basemap, ArcGISMap, MapView, SceneView, WebTileLayer) {
      this.gisAppliView = {
        mapView: null,
        sceneView: null,
        activeView: null,
        container: document.getElementById('mapView')
      }
      this.gisBackupViewParams = {
        map: null,
        zoom: 17,
        center: [120, 30],
        container: null
      }
      // basemap
      // const baseMap = new Basemap({
      //   portalItem: {
      //     id: 'bc19c34549de4000bcd91cef929420dc'
      //   }
      // })
      const baseMap2d = new WebTileLayer({ // 天地图影像
        urlTemplate: 'https://{subDomain}.tianditu.gov.cn/vec_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=vec&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TILECOL={col}&TILEROW={row}&TILEMATRIX={level}&tk=' + this.tdtTk,
        subDomains: ['t0', 't1', 't2', 't3', 't4', 't5', 't6', 't7'],
        copyright: '天地图底图'
      })
      const baseMap3d = new WebTileLayer({ // 天地图影像
        urlTemplate: 'https://{subDomain}.tianditu.gov.cn/vec_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=vec&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TILECOL={col}&TILEROW={row}&TILEMATRIX={level}&tk=' + this.tdtTk,
        subDomains: ['t0', 't1', 't2', 't3', 't4', 't5', 't6', 't7'],
        copyright: '天地图底图'
      })
      // 2D地图底图
      this.gisMap = new ArcGISMap({
        // basemap: this.crtBaseMap
        layers: [baseMap2d]
      })
      // 3D地图底图
      this.gisScene = new ArcGISMap({
        // basemap: baseMap,
        // basemap: 'satellite',
        layers: [baseMap3d],
        ground: 'world-elevation'
      })
      // init 2d mapView
      this.gisBackupViewParams.map = this.gisMap
      this.gisBackupViewParams.container = this.gisAppliView.container
      // this.gisAppliView.mapView = new MapView(this.gisBackupViewParams)
      this.gisAppliView.mapView = new MapView({
        map: this.gisMap,
        zoom: 17,
        center: [120, 30],
        container: this.gisAppliView.container
      })
      // init 3d sceneView
      this.gisBackupViewParams.map = this.gisScene
      this.gisBackupViewParams.container = null
      // this.gisAppliView.sceneView = new SceneView(this.gisBackupViewParams)
      this.gisAppliView.sceneView = new SceneView({
        map: this.gisScene,
        zoom: 17,
        center: [120.00000000, 30.00000000],
        container: null
      })
    },
    // 初始化弹窗
    initPopup () {
      this.gisMapView.popup.autoOpenEnabled = false
      this.gisSceneView.popup.autoOpenEnabled = false
      var popupOnEvt = (evt) => {
        console.log(evt, this.selectedData)
        switch (evt.action.id) {
          case 'showDetailsBtnS':
            console.log(this.eqmMntType, this.showDetailsAtmos)
            this.showDetailsAtmos = false
            this.showDetailsWater = false
            this.showDetailsUelectro = false
            this.showDetailsUwater = false
            this.clickMarkerDetails(this.selectedData)
            break
          case 'editBtnS':
            this.showMarkerDataEditor = false
            this.showMarkerDataEditor = true
            this.markerDataSetter = this.selectedData
            break
          case 'deleteBtnS':
            this.$confirm('确定删除该站点?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              api.hbOnlineMonitoringDelete({
                id: this.selectedData.order
              }).then((resD) => {
                if (resD.code === 200) {
                  this.addGraphics()
                  this.gisMapView.popup.close()
                  this.gisSceneView.popup.close()
                  this.$toast.text('删除成功')
                }
              })
            }).catch(() => {
              this.$toast.text('已取消删除')
            })
            break
          case 'deleteBtnG':
            this.$confirm('确定删除该图形?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              api.hbCoverInterfaceDelete({
                id: this.selectedData.id
              }).then((resD) => {
                if (resD.code === 200) {
                  this.addGraphics()
                  this.gisMapView.popup.close()
                  this.gisSceneView.popup.close()
                  this.$toast.text('删除成功')
                }
              })
            }).catch(() => {
              this.$toast.text('已取消删除')
            })
            break
          case 'createPoint':
            this.showObjDataSetterF = true
            break
        }
      }
      this.gisMapView.popup.on('trigger-action', popupOnEvt)
      this.gisSceneView.popup.on('trigger-action', popupOnEvt)
      console.log('initPopupCompvared')
    },
    // 点击事件
    initClickEvt () {
      // this.gisMapView.popup.autoOpenEnabled = false
      var clickEvt = (evt) => {
        this.gisMapView.popup.close()
        this.gisSceneView.popup.close()
        var lngLat = {
          // longitude: webMercatorUtils.xyToLngLat(evt.mapPoint.x, evt.mapPoint.y)[0],
          // latitude: webMercatorUtils.xyToLngLat(evt.mapPoint.x, evt.mapPoint.y)[1]
          latitude: evt.mapPoint.latitude,
          longitude: evt.mapPoint.longitude
        }
        this.objDataSetter.cPoint = lngLat
        console.log('lngLat', lngLat, evt)
        var openEvt = {
          title: '点击位置',
          content:
            `<p>坐标：${this.lnglatD2DMS(lngLat)} (${Math.round(lngLat.longitude * 1000000) / 1000000}, ${Math.round(lngLat.latitude * 1000000) / 1000000})`,
          location: evt.mapPoint,
          actions: [{
            title: '标记点',
            id: 'createPoint',
            image: require('@/assets/mapicons/create_circle.png')
          }]
        }
        this.gisMapView.popup.open(openEvt)
        // this.gisSceneView.popup.open(openEvt)
        var hitTestEvt = (response) => {
          console.log(response)
          if (response.results.length) {
            var graphicData = response.results[0].graphic.attributes.data
            var layer = response.results[0].graphic.layer.title
            console.log(layer, graphicData)
            if (layer === '站点图层' || layer === '3d站点图层') {
              this.clickMarker(graphicData, evt, lngLat)
              // this.clickMarkerDetails(graphicData)
            } else if (layer === '几何图层' || layer === '3d几何图层') {
              this.clickGraphics(graphicData, response.results[0])
            }
          }
        }
        this.gisMapView.hitTest(evt).then(hitTestEvt)
        // this.gisSceneView.hitTest(evt).then(hitTestEvt)
      }
      this.gisMapView.on('click', clickEvt)
      // this.gisSceneView.on('click', clickEvt)
    },
    // 自定义组件
    setFullScreenBtn () {
      var btn = document.createElement('img')
      btn.src = require('@/assets/mapicons/fullScreenEnter.png')
      btn.title = '进入全屏'
      btn.style.width = '32px'
      btn.style.height = '32px'
      btn.style.borderTop = 'solid 1px #cccccc'
      btn.style.cursor = 'pointer'
      btn.onclick = () => {
        // const mapContainer = document.getElementById('ehsmapwrap')
        const mapContainer = document.getElementById('arcgisMapDiv')
        if (this.mapFullScreenFlag) {
          document.webkitCancelFullScreen()
          btn.src = require('@/assets/mapicons/fullScreenEnter.png')
          btn.title = '进入全屏'
          // arcgisMapDiv.style.height = 'calc(100vh - 130px)'
        } else {
          mapContainer.webkitRequestFullScreen()
          btn.src = require('@/assets/mapicons/fullScreenExit.png')
          btn.title = '退出全屏'
          // arcgisMapDiv.style.height = 'calc(100vh - 40px)'
        }
        this.mapFullScreenFlag = !this.mapFullScreenFlag
      }
      this.fullScreenBtn = btn
      return this.fullScreenBtn
    },
    setSwitchMapBtn () {
      var btn = document.createElement('img')
      btn.src = require('@/assets/mapicons/mapSwitch.png')
      btn.title = '切换地图'
      btn.style.width = '32px'
      btn.style.height = '32px'
      btn.style.cursor = 'pointer'
      btn.style.marginBottom = '0'
      btn.style.borderBottom = '1px solid #cccccc'
      btn.onclick = () => {
        // if (this.viewDimensionType === '2d') {
        // this.changePType()
        let index = this.mapLayerTypeArr.indexOf(this.mapLayerType)
        this.mapLayerType = index < this.mapLayerTypeArr.length - 1 ? this.mapLayerTypeArr[++index] : this.mapLayerTypeArr[0]
        if (this.mapLayerType === 'WMTS') {
          this.gisWMTSLayer.visible = true
          this.gisWMTSLayerScene.visible = true
          this.tdtIBOLayer.visible = this.tdtCVALayer.visible
          this.tdtCIALayer.visible = this.tdtCVALayer.visible
          this.tdtIBOLayerScene.visible = this.tdtCVALayerScene.visible
          this.tdtCIALayerScene.visible = this.tdtCVALayerScene.visible
          this.tdtCVALayer.visible = false
          this.tdtCVALayerScene.visible = false
        } else {
          this.gisWMTSLayer.visible = false
          this.gisWMTSLayerScene.visible = false
          this.tdtCVALayer.visible = this.tdtCIALayer.visible
          this.tdtCVALayerScene.visible = this.tdtCIALayerScene.visible
          this.tdtIBOLayer.visible = false
          this.tdtCIALayer.visible = false
          this.tdtIBOLayerScene.visible = false
          this.tdtCIALayerScene.visible = false
        }
        // }
      }
      this.switchMapBtn = btn
      return this.switchMapBtn
    },
    setSwitchOSMBtn () {
      var btn = document.createElement('img')
      btn.src = require('@/assets/mapicons/osm.png')
      btn.title = '显示/隐藏路网'
      btn.style.width = '32px'
      btn.style.height = '32px'
      btn.style.cursor = 'pointer'
      // btn.style.marginBottom = '0'
      btn.onclick = () => {
        if (this.mapLayerType === 'WMTS') {
          this.tdtIBOLayer.visible = !this.tdtIBOLayer.visible
          this.tdtCIALayer.visible = !this.tdtCIALayer.visible
          this.tdtIBOLayerScene.visible = !this.tdtIBOLayerScene.visible
          this.tdtCIALayerScene.visible = !this.tdtCIALayerScene.visible
        } else {
          this.tdtCVALayer.visible = !this.tdtCVALayer.visible
          this.tdtCVALayerScene.visible = !this.tdtCVALayerScene.visible
        }
      }
      this.switchOSMBtn = btn
      return this.switchOSMBtn
    },
    setSwitchDBtn () {
      var btn = document.createElement('img')
      btn.src = require('@/assets/mapicons/3D.png')
      btn.title = '切换为3D'
      btn.style.width = '32px'
      btn.style.height = '32px'
      btn.style.cursor = 'pointer'
      // btn.style.marginBottom = '0'
      btn.onclick = () => {
        this.gisBackupViewParams.center = this.gisAppliView.activeView.center
        this.gisBackupViewParams.scale = Math.round(this.gisAppliView.activeView.scale)
        this.gisAppliView.sceneView.scale = this.gisBackupViewParams.scale
        this.gisAppliView.mapView.scale = this.gisBackupViewParams.scale
        this.gisAppliView.activeView.container = null
        this.$nextTick().then(() => {
          if (this.viewDimensionType === '2d') {
            this.gisAppliView.sceneView.center = this.gisBackupViewParams.center
            this.gisAppliView.activeView = this.gisAppliView.sceneView
            this.gisAppliView.activeView.container = this.gisAppliView.container
            this.switchDBtn.title = '切换为2D'
            this.switchDBtn.src = require('@/assets/mapicons/2D.png')
            this.viewDimensionType = '3d'
          } else {
            this.gisAppliView.mapView.center = this.gisBackupViewParams.center
            this.gisAppliView.activeView = this.gisAppliView.mapView
            this.gisAppliView.activeView.container = this.gisAppliView.container
            this.switchDBtn.title = '切换为3D'
            this.switchDBtn.src = require('@/assets/mapicons/3D.png')
            this.viewDimensionType = '2d'
          }
          this.addGraphics()
        })
      }
      this.switchDBtn = btn
      return this.switchDBtn
    },
    setShowTimeSlider () {
      var btn = document.createElement('img')
      btn.src = require('@/assets/mapicons/timeSlider.png')
      btn.title = '站点记录'
      btn.style.width = '32px'
      btn.style.height = '32px'
      btn.style.cursor = 'pointer'
      btn.style.marginBottom = '0'
      btn.onclick = () => {
        var viewType
        if (this.viewDimensionType === '2d') {
          viewType = 'gisMapView'
        } else {
          viewType = 'gisSceneView'
        }
        if (this.showTimeSliderFlag) {
          this[viewType].ui.remove(this.gisTimeSlider)
          this.showTimeSliderFlag = false
          this.addGraphics('stations')
        } else {
          this[viewType].ui.add(this.gisTimeSlider, 'bottom-left')
          this.showTimeSliderFlag = true
          this.addGraphics('stations')
        }
      }
      this.showTimeSliderBtn = btn
      return this.showTimeSliderBtn
    },
    // 站点记录时间轴
    createTimeSlider (endDate) {
      loadModules([
        'esri/widgets/TimeSlider'
      ], { css: true }).then(([
        TimeSlider
      ]) => {
        var startDate = new Date()
        // var endDate = new Date()
        startDate.setDate(endDate.getDate() - 1)
        startDate.setMinutes(0)
        startDate.setSeconds(0)
        var stopsDates = [endDate]
        var intervalTime = 1
        for (var i = 0; i < 24; i++) {
          var stopDate = new Date()
          stopDate.setHours(endDate.getHours() - i * intervalTime)
          stopDate.setMinutes(0)
          stopDate.setSeconds(0)
          stopsDates.push(stopDate)
        }
        stopsDates.push(startDate)
        console.log('stopsDates', stopsDates)
        this.gisTimeSlider = new TimeSlider({
          // container: 'timeSliderView',
          // view: this.gisMapView,
          mode: 'cumulative-from-start',
          fullTimeExtent: {
            start: startDate,
            end: endDate
          },
          timeExtent: {
            start: null,
            end: endDate
          },
          playRate: 1000,
          stops: {
            // interval: {
            //   value: 1,
            //   unit: 'years'
            // },
            dates: stopsDates
          },
          tickConfigs: [{
            values: 0
          }],
          layout: 'wide',
          labelFormatFunction: (value, type, element, layout) => {
            switch (type) {
              case 'min':
              case 'max':
                break
              case 'extent':
                element.setAttribute(
                  'style',
                  'font-family: "Orbitron", sans-serif; font-size: 18px; color: red;'
                )
                var actStopDateS = this.dateUTC2GMT08(value[1])
                element.innerText = actStopDateS.slice(0, 16)
                if (this.activeStopDate !== actStopDateS) {
                  this.activeStopDate = actStopDateS
                  console.log('v', value[1], this.activeStopDate)
                  this.addGraphics('stations')
                }
                break
            }
          }
        })
        console.log('timeExtent', this.gisTimeSlider.timeExtent.end.toJSON())
        console.log('gisTimeSlider', this.gisTimeSlider)
      })
    },
    gisMeasurement () {
      var that = this
      loadModules([
        'esri/widgets/DistanceMeasurement2D',
        'esri/widgets/AreaMeasurement2D'
      ], { css: true }).then(([
        DistanceMeasurement2D,
        AreaMeasurement2D
      ]) => {
        that.gisMapView.ui.add('topbarMeasure', { position: 'top-right', index: 0 })
        document.getElementById('distanceButton').addEventListener('click', function () {
          setActiveWidget(null)
          if (!this.classList.contains('active')) {
            setActiveWidget('distance')
          } else {
            setActiveButton(null)
          }
        })
        document.getElementById('areaButton').addEventListener('click', function () {
          setActiveWidget(null)
          if (!this.classList.contains('active')) {
            setActiveWidget('area')
          } else {
            setActiveButton(null)
          }
        })
        function setActiveWidget (type) {
          switch (type) {
            case 'distance':
              that.activeWidget = new DistanceMeasurement2D({
                view: that.gisMapView
              })
              // skip the initial 'new measurement' button
              that.activeWidget.viewModel.start()
              that.gisMapView.ui.add(that.activeWidget, 'top-right')
              setActiveButton(document.getElementById('distanceButton'))
              break
            case 'area':
              that.activeWidget = new AreaMeasurement2D({
                view: that.gisMapView,
                label: '测距离'
              })
              // skip the initial 'new measurement' button
              that.activeWidget.viewModel.start()
              that.gisMapView.ui.add(that.activeWidget, 'top-right')
              setActiveButton(document.getElementById('areaButton'))
              break
            case null:
              if (that.activeWidget) {
                that.gisMapView.ui.remove(that.activeWidget)
                that.activeWidget.destroy()
                that.activeWidget = null
              }
              break
          }
        }
        function setActiveButton (selectedButton) {
          // focus the view to activate keyboard shortcuts for sketching
          that.gisMapView.focus()
          var elements = document.getElementsByClassName('active')
          for (var i = 0; i < elements.length; i++) {
            elements[i].classList.remove('active')
          }
          if (selectedButton) {
            selectedButton.classList.add('active')
          }
        }
      })
    },
    // 格式转换器
    lnglatD2DMS (mtlnglat) {
      var mtLng = mtlnglat.longitude
      var mtLat = mtlnglat.latitude
      var d, m, s, t, lng, lat, lnglat
      d = parseInt(mtLng)
      m = parseInt((mtLng - d) * 60)
      s = Math.round(((mtLng - d) * 60 - m) * 60)
      if (d >= 0) {
        t = 'E'
      } else {
        t = 'W'
        d = -d
      }
      lng = d + '°' + m + '\'' + s + '"' + t
      d = parseInt(mtLat)
      m = parseInt((mtLat - d) * 60)
      s = Math.round(((mtLat - d) * 60 - m) * 60)
      if (d >= 0) {
        t = 'N'
      } else {
        t = 'S'
        d = -d
      }
      lat = d + '°' + m + '\'' + s + '"' + t
      lnglat = lng + ', ' + lat
      return lnglat
    },
    colorHArr2DArr (colorHArr) {
      var colorDArr = []
      JSON.parse(colorHArr).forEach((item) => {
        var dItem = Number(parseInt(item, 16).toString(10))
        colorDArr.push(dItem)
      })
      return colorDArr
    },
    colorHStr2HArr (colorHStr) {
      if (!colorHStr) {
        return ['00', '00', '00']
      } else {
        var colorHArr = [
          colorHStr.slice(1, 3),
          colorHStr.slice(3, 5),
          colorHStr.slice(5, 7)
        ]
        return colorHArr
      }
    },
    colorHStr2DArr (colorHStr) {
      var colorDArr = [
        Number(parseInt(colorHStr.slice(1, 3), 16).toString(10)),
        Number(parseInt(colorHStr.slice(3, 5), 16).toString(10)),
        Number(parseInt(colorHStr.slice(5, 7), 16).toString(10))
      ]
      return colorDArr
    },
    dateUTC2GMT08 (dateUTC) {
      var gmt08T = dateUTC.toLocaleTimeString('chinese', { hour12: false })
      var gmt08DArr = dateUTC.toLocaleDateString().split('/')
      var y = gmt08DArr[0]
      var m = gmt08DArr[1] < 10 ? '0' + gmt08DArr[1] : gmt08DArr[1]
      var d = gmt08DArr[2] < 10 ? '0' + gmt08DArr[2] : gmt08DArr[2]
      var gmt08 = y + '-' + m + '-' + d + ' ' + gmt08T
      return gmt08
    },
    // 站点列表
    getStationsList () {
      this.filterType = []
      if (!this.filterblue && !this.filtergreen && !this.filteryellow && !this.filterred && !this.filterblack) {
        console.log('getAll')
        this.filterType = [0, 1, 2, 3, 4]
      } else {
        if (this.filterblack) {
          console.log('getBlack')
          this.filterType.push(0)
        }
        if (this.filterblue) {
          console.log('getblue')
          this.filterType.push(1)
        }
        if (this.filtergreen) {
          console.log('getgreen')
          this.filterType.push(2)
        }
        if (this.filteryellow) {
          console.log('getyellow')
          this.filterType.push(3)
        }
        if (this.filterred) {
          console.log('getred')
          this.filterType.push(4)
        }
      }
      if (this.subTypeMode === 'monitors') {
        this.showVideoPlayer = false
        this.$nextTick(function () {
          this.showVideoPlayer = true
        })
      }
      if (this.subTypeMode === 'dataMng') {
        this.hideLeftDiv = false
      } else {
        this.hideLeftDiv = true
      }
    },
    selectObjType (type) {
      switch (type) {
        case 'objArea':
          this.showSelectObjTypeFlag = false
          this.$nextTick(() => {
            this.showCreateObjAreaFlag = true
          })
          break
        case 'building':
          this.showSelectObjTypeFlag = false
          this.$nextTick(() => {
            this.showCreateBuildingFlag = true
          })
          break
      }
    },
    addGraphics (addType) {
      loadModules([
        'esri/Graphic',
        'esri/geometry/Circle'
      ], { css: true }).then(([
        Graphic,
        GeometryCircle
      ]) => {
        this.gisMapView.popup.close()
        this.gisSceneView.popup.close()
        this.showObjDataSetterF = false
        this.initSLCcltor()
        if (addType === 'graphics' || !addType) {
          api.hbCoverInterfaceEnquiry({
            province: this.mapProvinceActive
          }).then(resG => {
            if (resG.code === 200) {
              console.log('reaG', resG.data)
              this.gisGraphicsLayer.removeAll()
              this.gisGraphicsLayerScene.removeAll()
              this.gisGraphicsLayerSceneAux.removeAll()
              this.addObjAreas(Graphic, resG.data.objAreaOptions)
              this.addBuildings(Graphic, resG.data.buildingOptions)
              // this.addCylinders(Graphic, GeometryCircle, resG.data.cylinderOptions)
              this.addPoints(Graphic, resG.data.pointOptions)
              // this.gisSketch.delete()
              console.log('delete compvared')
            }
          })
        }
        if (addType === 'stations' || !addType) {
          this.addStations(Graphic)
        }
      })
    },
    addStations (Graphic) {
      console.log(this.homeTypeTab)
      console.log(this.filterType)
      this.getStationsList()
      var time = this.dateUTC2GMT08(new Date())
      var filterType = JSON.stringify(this.filterType).slice(1, -1)
      var enquiryPusher = {
        time: this.showTimeSliderFlag ? this.activeStopDate : time,
        markerType: filterType,
        province: this.mapProvinceActive
      }
      // var enquiryPusher = { markerType: '0,1,2,3,4' }
      if (this.homeTypeTab !== 'map') { enquiryPusher.mntType = this.homeTypeTab } else {}
      if (this.markerSearch !== '') { enquiryPusher.markerName = this.markerSearch }
      api.hbOnlineMonitoringEnquiry(enquiryPusher).then(resS => {
        if (resS.code === 200) {
          console.log('resS', resS.data)
          this.gisStationsLayer.removeAll()
          this.gisStationsLayerScene.removeAll()
          var tempArr = []
          resS.data.forEach(item => {
            var pos = JSON.parse(item.markerData.markerPosition)
            // addToList
            var enquiryPusher = {
              order: item.id,
              mntType: item.mntType,
              mntVideo: item.mntVideo,
              mntDataSrc: item.mntDataSrc,
              markerData: {
                markerName: item.markerData.markerName,
                markerTypeValue: item.markerData.markerTypeValue,
                markerType: item.markerData.markerType,
                markerPosition: pos
              },
              eqmData: item.eqmData
            }
            if ('atmosClass' in item.eqmData) { enquiryPusher.eqmData.atmosClass = item.eqmData.atmosClass }
            if ('waterClass' in item.eqmData) { enquiryPusher.eqmData.waterClass = item.eqmData.waterClass }
            tempArr.push(enquiryPusher)
            // addToMap
            var mntType = item.mntType
            var mkType = item.markerData.markerType
            var smntt, smkt, plclr
            if (mntType === 'map') { smntt = 'map' } else
            if (mntType === 'atmos') { smntt = 'atmos' } else
            if (mntType === 'water') { smntt = 'water' } else
            if (mntType === 'uelectro') { smntt = 'uelectro' } else
            if (mntType === 'uwater') { smntt = 'uwater' }
            if (mkType === 0) {
              smkt = 'black'
              plclr = [51, 51, 51]
            } else if (mkType === 1) {
              smkt = 'blue'
              plclr = [17, 149, 219]
            } else if (mkType === 2) {
              smkt = 'green'
              plclr = [42, 165, 21]
            } else if (mkType === 3) {
              smkt = 'yellow'
              plclr = [239, 179, 54]
            } else if (mkType === 4) {
              smkt = 'red'
              plclr = [216, 30, 6]
            }
            var smb = this.markerIconList[smntt + 'icon'][smkt]
            // console.log(smntt, smkt, smb)
            var point = new Graphic({
              geometry: {
                type: 'point',
                longitude: pos[0],
                latitude: pos[1],
                z: 90
              },
              symbol: {
                type: 'picture-marker',
                url: smb,
                width: '32px',
                height: '32px'
              },
              attributes: {
                data: enquiryPusher
              }
            })
            if (this.viewDimensionType === '2d') {
              this.gisStationsLayer.add(point)
            } else {
              this.gisStationsLayerScene.add(point)
              var polyline = new Graphic({
                geometry: {
                  type: 'polyline',
                  paths: [
                    [pos[0], pos[1], 0],
                    [pos[0], pos[1], 75]
                  ]
                },
                symbol: {
                  type: 'simple-line',
                  color: [...plclr, 0.5],
                  width: 2
                }
              })
              this.gisStationsLayerScene.add(polyline)
            }
          })
          // this.gisStationsLayer.on('rightclick', (ev) => {
          //   console.log(ev)
          // })
          this.markerDatas = tempArr
          this.markerDataMntList = tempArr
          console.log('markerDatas', this.markerDatas)
          if (this.markerDatas.length !== 0) {
            this.eqmOnlineId = this.markerDatas[0].order
            this.eqmOnlineName = this.markerDatas[0].markerData.markerName
            this.eqmMntUrl = this.markerDatas[0].mntVideo.videoSrc
            this.startMntVideos()
          } else {
            this.eqmOnlineId = 0
            this.eqmOnlineName = ''
            this.eqmMntUrl = ''
          }
          if (this.homeTypeTab === 'atmos') {
            this.getEQMAtmos()
          } else if (this.homeTypeTab === 'water') {
            this.getEQMWater()
          }
        }
      })
    },
    addObjAreas (Graphic, data) {
      data.forEach(item => {
        var polygon = new Graphic({
          geometry: {
            type: 'polygon',
            rings: JSON.parse(item.path)
          },
          symbol: {
            type: 'simple-fill', // autocasts as new SimpleFillSymbol()
            color: [...this.colorHArr2DArr(item.colorHArr), 0.3],
            outline: {
              color: [...this.colorHArr2DArr(item.colorHArr), 1],
              width: 1
            }
          },
          attributes: {
            data: item
          }
        })
        if (this.viewDimensionType === '2d') {
          this.gisGraphicsLayer.graphics.add(polygon)
        } else {
          this.gisGraphicsLayerScene.graphics.add(polygon)
        }
      })
      console.log('addObjAreas compvared', data)
    },
    addBuildings (Graphic, data) {
      data.forEach(item => {
        var dataRings = JSON.parse(item.bounds)
        var rings = []
        if (this.viewDimensionType === '2d') {
          rings = dataRings
        } else {
          var tempArr = []
          for (var i = 0; i < dataRings.length; i++) {
            // 顶面
            var ringItem = dataRings[i]
            ringItem.push(item.height)
            tempArr.push(ringItem)
            // 侧面
            var bErr = 0.000000001
            var iErr = i + 1
            if (i >= dataRings.length - 1) {
              iErr = 0
            }
            var iair0t = [dataRings[i][0], dataRings[i][1], item.height]
            var iair0b = [dataRings[i][0] + bErr, dataRings[i][1] + bErr, 0]
            var iair1t = [dataRings[iErr][0], dataRings[iErr][1], item.height]
            var iair1b = [dataRings[iErr][0] + bErr, dataRings[iErr][1] + bErr, 0]
            var itemAuxItemRings = [iair0t, iair1t, iair1b, iair0b]
            console.log('itemAuxItemRings', iErr, itemAuxItemRings)
            var itemAuxItem = new Graphic({
              geometry: {
                type: 'polygon',
                rings: itemAuxItemRings
              },
              symbol: {
                type: 'simple-fill', // autocasts as new SimpleFillSymbol()
                color: [...this.colorHArr2DArr(item.colorHArr), 0.5],
                outline: {
                  color: [...this.colorHArr2DArr(item.colorHArr), 1],
                  width: 1
                }
              }
            })
            this.gisGraphicsLayerSceneAux.graphics.add(itemAuxItem)
          }
          rings = tempArr
        }
        var polygon = new Graphic({
          geometry: {
            type: 'polygon',
            rings: rings
          },
          symbol: {
            type: 'simple-fill', // autocasts as new SimpleFillSymbol()
            color: [...this.colorHArr2DArr(item.colorHArr), 0.7],
            outline: {
              color: [...this.colorHArr2DArr(item.colorHArr), 1],
              width: 1
            }
          },
          attributes: {
            data: item
          },
          popupTemplate: {
            title: 'title'
          }
        })
        if (this.viewDimensionType === '2d') {
          this.gisGraphicsLayer.graphics.add(polygon)
        } else {
          this.gisGraphicsLayerScene.graphics.add(polygon)
        }
      })
      console.log('addBuildings compvared')
    },
    addPoints (Graphic, data) {
      data.forEach(item => {
        var point = new Graphic({
          geometry: {
            type: 'point',
            longitude: JSON.parse(item.center)[0],
            latitude: JSON.parse(item.center)[1]
          },
          symbol: {
            type: 'simple-marker', // autocasts as new SimpleFillSymbol()
            color: [...JSON.parse(item.colorHArr), 0.8],
            size: 6,
            outline: {
              color: [255, 255, 255, 0.8],
              width: 1
            }
          },
          attributes: {
            data: item
          },
          popupTemplate: {
            title: 'title'
          }
        })
        this.gisGraphicsLayer.add(point)
        console.log('addPoint', point)
      })
    },
    clickMarker (data) {
      var dataPos = {
        longitude: data.markerData.markerPosition[0],
        latitude: data.markerData.markerPosition[1],
        z: 90
      }
      this.selectedData = data
      var openEvt = {
        title: data.markerData.markerName,
        // content: '<p>坐标：' + JSON.stringify(lngLat), // content displayed in the popup
        content:
          `<p>坐标：${this.lnglatD2DMS(dataPos)} (${Math.round(dataPos.longitude * 1000000) / 1000000}, ${Math.round(dataPos.latitude * 1000000) / 1000000})`,
        // location: evt.mapPoint // Set the location of the popup to the clicked location
        location: dataPos,
        actions: [{
          title: '详情',
          id: 'showDetailsBtnS',
          image: require('@/assets/mapicons/details.png')
        }]
      }
      this.gisMapView.popup.open(openEvt)
      this.gisSceneView.popup.open(openEvt)
      console.log(this.gisSceneView)
      // 更新统计图
      this.eqmOnlineId = data.order
      this.eqmOnlineName = data.markerData.markerName
      if (this.homeTypeTab === 'atmos') {
        this.getEQMAtmos()
      } else if (this.homeTypeTab === 'water') {
        this.getEQMWater()
      }
      this.eqmMntUrl = data.mntVideo.videoSrc
      this.startMntVideos()
    },
    clickGraphics (data, clkData) {
      this.selectedData = data
      var titleName = ''
      var cPoint = null
      switch (data.mapObjType) {
        case 'objArea':
          titleName = '区域'
          cPoint = clkData.graphic.geometry.centroid
          break
        case 'building':
          titleName = '建筑物'
          cPoint = clkData.graphic.geometry.centroid
          break
        // case 'cylinder':
        //   titleName = '建筑物'
        //   cPoint = clkData.graphic.geometry.centroid
        //   break
        case 'point':
          titleName = '点'
          cPoint = clkData.graphic.geometry
          break
      }
      var cPos = {
        longitude: cPoint.longitude,
        latitude: cPoint.latitude,
        z: data.height
      }
      this.gisMapView.popup.open({
        title: titleName,
        // content: '<p>坐标：' + JSON.stringify(lngLat), // content displayed in the popup
        content:
          `<p>中点坐标：${this.lnglatD2DMS(cPos)} (${Math.round(cPos.longitude * 1000000) / 1000000}, ${Math.round(cPos.latitude * 1000000) / 1000000})`,
        // location: evt.mapPoint // Set the location of the popup to the clicked location
        location: cPos,
        actions: []
      })
    },
    createPointData () {
      var ds = {
        mapObjType: 'point',
        colorHArr: JSON.stringify(this.colorHStr2HArr(this.objDataSetter.colorName)),
        center: JSON.stringify([this.objDataSetter.cPoint.longitude, this.objDataSetter.cPoint.latitude]),
        province: this.mapProvinceActive
      }
      api.hbCoverInterfaceAdd(ds).then(res => {
        console.log(res)
        this.addGraphics()
      })
    },
    clickMarkerDetails (data) {
      this.eqmMntOrder = data.order
      this.eqmMntType = data.mntType
      if (data.mntType === 'water') {
        this.eqmClass = data.eqmData.waterClass
      }
      this.showDetailsType()
    },
    showDetailsType () {
      if (this.eqmMntType === 'atmos') {
        this.showDetailsAtmos = true
      } else if (this.eqmMntType === 'water') {
        this.showDetailsWater = true
      } else if (this.eqmMntType === 'uelectro') {
        this.showDetailsUelectro = true
      } else if (this.eqmMntType === 'uwater') {
        this.showDetailsUwater = true
      }
      console.log(this.eqmMntType, this.showDetailsAtmos)
    },
    getHomeDatas () {
      api.hbOnlineHome({
        province: this.mapProvinceActive
        // mntType: ''
      }).then(res => {
        this.chartsDatas = res.data
        console.log('hbOnlineHomeData', this.chartsDatas)
        this.$nextTick(() => {
          this.initSLCcltor()
        })
      })
    },
    initSLCcltor () {
      this.clearMap()
      this.initSLt2Ccltor()
      this.initSLt3Ccltor()
      this.initSLt4Ccltor()
      this.initSLt5Ccltor()
    },
    initSLt2Ccltor () {
      var hpSLt2Box = document.getElementById('hpSLt2Box')
      this.hpSLt2BoxShowF = false
      console.log('hpSLt2Box', hpSLt2Box.scrollHeight, hpSLt2Box.clientHeight, hpSLt2Box.scrollTop)
      this.$nextTick(() => {
        if (hpSLt2Box.scrollHeight > hpSLt2Box.clientHeight) {
          this.hpSLt2BoxShowF = true
          this.hpSLt2BoxHeight = hpSLt2Box.scrollHeight
          this.hpSLt2BoxCcltor = setInterval(this.initHpSLt2BoxCcltor, this.hpSLtBoxRTI)
          // this.hpSLt2BoxCcltor = setInterval(this['initHpSLt2BoxCcltor'], 50)
          console.log('scr')
        } else {
          this.hpSLt2BoxShowF = false
          this.hpSLt2BoxHeight = hpSLt2Box.scrollHeight
          clearInterval(this.hpSLt2BoxCcltor)
          console.log('nscr')
        }
      })
    },
    initSLt3Ccltor () {
      var hpSLt3Box = document.getElementById('hpSLt3Box')
      this.hpSLt3BoxShowF = false
      console.log('hpSLt3Box', hpSLt3Box.scrollHeight, hpSLt3Box.clientHeight, hpSLt3Box.scrollTop)
      this.$nextTick(() => {
        if (hpSLt3Box.scrollHeight > hpSLt3Box.clientHeight) {
          this.hpSLt3BoxShowF = true
          this.hpSLt3BoxHeight = hpSLt3Box.scrollHeight
          this.hpSLt3BoxCcltor = setInterval(this.initHpSLt3BoxCcltor, this.hpSLtBoxRTI)
          console.log('scr')
        } else {
          this.hpSLt3BoxShowF = false
          this.hpSLt3BoxHeight = hpSLt3Box.scrollHeight
          clearInterval(this.hpSLt3BoxCcltor)
          console.log('nscr')
        }
      })
    },
    initSLt4Ccltor () {
      var hpSLt4Box = document.getElementById('hpSLt4Box')
      this.hpSLt4BoxShowF = false
      console.log('hpSLt4Box', hpSLt4Box.scrollHeight, hpSLt4Box.clientHeight, hpSLt4Box.scrollTop)
      this.$nextTick(() => {
        if (hpSLt4Box.scrollHeight > hpSLt4Box.clientHeight) {
          this.hpSLt4BoxShowF = true
          this.hpSLt4BoxHeight = hpSLt4Box.scrollHeight
          this.hpSLt4BoxCcltor = setInterval(this.initHpSLt4BoxCcltor, this.hpSLtBoxRTI)
          console.log('scr')
        } else {
          this.hpSLt4BoxShowF = false
          this.hpSLt4BoxHeight = hpSLt4Box.scrollHeight
          clearInterval(this.hpSLt4BoxCcltor)
          console.log('nscr')
        }
      })
    },
    initSLt5Ccltor () {
      var hpSLt5Box = document.getElementById('hpSLt5Box')
      this.hpSLt5BoxShowF = false
      console.log('hpSLt5Box', hpSLt5Box.scrollHeight, hpSLt5Box.clientHeight, hpSLt5Box.scrollTop)
      this.$nextTick(() => {
        if (hpSLt5Box.scrollHeight > hpSLt5Box.clientHeight) {
          this.hpSLt5BoxShowF = true
          this.hpSLt5BoxHeight = hpSLt5Box.scrollHeight
          this.hpSLt5BoxCcltor = setInterval(this.initHpSLt5BoxCcltor, this.hpSLtBoxRTI)
          console.log('scr')
        } else {
          this.hpSLt5BoxShowF = false
          this.hpSLt5BoxHeight = hpSLt5Box.scrollHeight
          clearInterval(this.hpSLt5BoxCcltor)
          console.log('nscr')
        }
      })
    },
    initHpSLt2BoxCcltor () {
      var hpSLtBox2B = document.getElementById('hpSLt2Box')
      if (hpSLtBox2B.scrollTop >= this.hpSLt2BoxHeight) {
        hpSLtBox2B.scrollTop = this.hpSLtBoxScrollTopI
      }
      hpSLtBox2B.scrollTop += this.hpSLtBoxScrollTopI
      console.log('initHpSLt2BoxCcltor')
    },
    initHpSLt3BoxCcltor () {
      var hpSLtBox3B = document.getElementById('hpSLt3Box')
      if (hpSLtBox3B.scrollTop >= this.hpSLt3BoxHeight) {
        hpSLtBox3B.scrollTop = this.hpSLtBoxScrollTopI
      }
      hpSLtBox3B.scrollTop += this.hpSLtBoxScrollTopI
      console.log('initHpSLt3BoxCcltor')
    },
    initHpSLt4BoxCcltor () {
      var hpSLtBox4B = document.getElementById('hpSLt4Box')
      if (hpSLtBox4B.scrollTop >= this.hpSLt4BoxHeight) {
        hpSLtBox4B.scrollTop = this.hpSLtBoxScrollTopI
      }
      hpSLtBox4B.scrollTop += this.hpSLtBoxScrollTopI
      console.log('initHpSLt4BoxCcltor')
    },
    initHpSLt5BoxCcltor () {
      var hpSLtBox5B = document.getElementById('hpSLt5Box')
      if (hpSLtBox5B.scrollTop >= this.hpSLt5BoxHeight) {
        hpSLtBox5B.scrollTop = this.hpSLtBoxScrollTopI
      }
      hpSLtBox5B.scrollTop += this.hpSLtBoxScrollTopI
      console.log('initHpSLt5BoxCcltor')
    },
    getEQMAtmos () {
      api.hbOnlineEnquiry({
        pages: 10,
        pageNo: 1,
        onlineId: this.eqmOnlineId
      }).then(res => {
        var atmosItems = {
          hour: ['oneSO2', 'oneNO2', 'oneCO', 'oneO3'],
          hours24: ['daySO2', 'dayNO2', 'dayCO', 'dayPM10', 'dayPM2o5']
        }
        var rowItems = {
          hour: ['eqmaSO2', 'eqmaNO2', 'eqmaCO', 'eqmaO3'],
          hours24: ['eqmaSO2', 'eqmaNO2', 'eqmaCO', 'eqmaPM10', 'eqmaPM2o5']
        }
        var tempArr = []
        var atmosData = res.data.atmos
        atmosData.forEach(item => {
          var enquiryPusher = {}
          enquiryPusher.order = item.id
          if ('time' in item) { enquiryPusher.eqmTime = item.time } else { enquiryPusher.eqmTime = '' }
          for (var i = 0; i < atmosItems[this.eqmAtmosAverage].length; i++) {
            // console.log('atmosItems[this.eqmAtmosAverage][i]', atmosItems[this.eqmAtmosAverage][i])
            if (atmosItems[this.eqmAtmosAverage][i] in item) { enquiryPusher[rowItems[this.eqmAtmosAverage][i]] = item[atmosItems[this.eqmAtmosAverage][i]] } else { enquiryPusher[rowItems[this.eqmAtmosAverage][i]] = null }
          }
          enquiryPusher.editFlag = false
          tempArr.push(enquiryPusher)
        })
        this.eqmAtmosData = tempArr
        console.log('eqmAtmosData', this.eqmAtmosData)
        this.chartInit('chartInitItemsa')
      })
    },
    getEQMWater () {
      api.hbOnlineEnquiry({
        pages: 10,
        pageNo: 1,
        onlineId: this.eqmOnlineId
      }).then(res => {
        var rowItems = [
          'eqmwCODMn', 'eqmwCOD', 'eqmwBOD5', 'eqmwNH3_N'
        ]
        var waterItems = [
          'basicItemsCODMn', 'basicItemsCOD', 'basicItemsBOD5', 'basicItemsNH3N'
        ]
        console.log('res', res.data)
        var tempArr = []
        var waterData = res.data.water
        waterData.forEach(item => {
          var enquiryPusher = {}
          enquiryPusher.order = item.id
          if ('time' in item) { enquiryPusher.eqmTime = item.time } else { enquiryPusher.eqmTime = '' }
          for (var i = 0; i < waterItems.length; i++) {
            // console.log(waterItems[i])
            if (waterItems[i] in item) { enquiryPusher[rowItems[i]] = item[waterItems[i]] } else { enquiryPusher[rowItems[i]] = null }
          }
          enquiryPusher.editFlag = false
          tempArr.push(enquiryPusher)
        })
        this.eqmWaterData = tempArr
        console.log('eqmWaterData', this.eqmWaterData)
        this.chartInit('chartInitItemsw')
      })
    },
    provinceChange () {
      api.appUserMapProvinceUpdate({
        province: this.mapProvinceActive
      }).then(resPr => {
        console.log(resPr)
      })
      if (this.viewDimensionType === '2d' && this.gisSearch) {
        this.gisSearch.searchTerm = this.mapProvinceActive
        this.gisSearch.search()
      } else if (this.viewDimensionType === '3d' && this.gisSearchScene) {
        this.gisSearchScene.searchTerm = this.mapProvinceActive
        this.gisSearchScene.search()
      }
      this.getHomeDatas()
      this.addGraphics()
    },
    startMntVideos () {
      console.log('eqmMntUrl', this.eqmMntUrl, this.eqmMntUrl.slice(-3), this.markerDatas)
      this.player = null
      setTimeout(() => {
        if (flvjs.isSupported() && this.eqmMntUrl.slice(-3) === 'flv') {
          var videoElement = document.getElementById('mntVideo')
          this.player = flvjs.createPlayer({
            type: 'flv', // 媒体类型 flv 或 mp4
            isLive: true, // 是否为直播流
            hasAudio: true, // 是否开启声音
            url: this.eqmMntUrl // 视频流地址
          })
          this.player.attachMediaElement(videoElement)
          this.player.load()
          // this.player.play()
        } else {
          console.log('flvjs不支持')
          this.eqmMntUrl = ''
        }
      }, 1000)
    },
    getCpnInfo () {
      api.hbManagementInformationEnquiry({
        pages: 99,
        pageNo: 1,
        category: 0
      }).then(res => {
        console.log('res', res)
        this.cpnInfoDatas = res.data.list
      })
    },
    chartInit (type) {
      console.log('type', type)
      switch (type) {
        case 'chartInit211a':
          this.chartInit211a()
          break
        case 'chartInit211w':
          this.chartInit211w()
          break
        case 'chartInitItemsa':
          this.chartInitItemsa()
          break
        case 'chartInitItemsw':
          this.chartInitItemsw()
          break
        case 'chartInit221a':
          this.chartInit221a()
          break
        case 'chartInit221w':
          this.chartInit221w()
          break
        case 'chartInitT2Bara':
          this.chartInitT2Bara()
          break
        case 'chartInitT2Barw':
          this.chartInitT2Barw()
          break
        default:
          this.chartInit211a()
          this.chartInit211w()
          this.chartInitItemsa()
          this.chartInitItemsw()
          this.chartInit221a()
          this.chartInit221w()
          this.chartInitT2Bara()
          this.chartInitT2Barw()
          break
      }
    },
    chartInit211a () {
      var data211a = []
      for (var i = 0; i < this.siteType.length - 1; i++) {
        data211a.push({
          name: this.siteType[i],
          y: this.chartsDatas.atmos.itemBasicDatas['pieT' + Number(i + 1) + 'Ratio'],
          color: this.color[i]
        })
      }
      this.chartOptions211a = {
        chart: {
          type: 'pie',
          backgroundColor: null
        },
        title: {
          text: null
        },
        credits: {
          enabled: false
        },
        tooltip: {
          valueSuffix: '%'
        },
        ploOptions: {
          pie: {
            showInLegend: true,
            shadow: true,
            center: ['50%', '50%']
          }
        },
        series: [{
          name: '占比',
          size: '80%',
          innerSize: '60%',
          data: data211a
        }],
        responsive: {
          rules: [{
            condition: {
              maxWidth: 480
            },
            chartOptions: {
              legend: {
                layout: 'horizontal',
                align: 'center',
                veticalAlign: 'bottom'
              }
            }
          }]
        }
      }
    },
    chartInit211w () {
      var data211w = []
      for (var i = 0; i < this.siteType.length - 1; i++) {
        data211w.push({
          name: this.siteType[i],
          y: this.chartsDatas.water.itemBasicDatas['pieT' + Number(i + 1) + 'Ratio'],
          color: this.color[i]
        })
      }
      this.chartOptions211w = {
        chart: {
          type: 'pie',
          backgroundColor: null
        },
        title: {
          text: null
          // text: '水质主要污染物比例'
        },
        credits: {
          enabled: false
        },
        tooltip: {
          valueSuffix: '%'
        },
        ploOptions: {
          pie: {
            showInLegend: true,
            shadow: true,
            center: ['50%', '50%']
          }
        },
        series: [{
          name: '占比',
          size: '80%',
          innerSize: '60%',
          data: data211w,
          dataLabels: {
            softConnector: false
            // formatter: function () {
            //   // 通过函数判断是否显示数据标签，为了防止数据标签过于密集
            //   return this.y > 1 ? '<b>' + this.point.name + ':</b> ' + this.y + '%' : null
            // }
          }
        }],
        responsive: {
          rules: [{
            condition: {
              maxWidth: 480
            },
            chartOptions: {
              legend: {
                layout: 'horizontal',
                align: 'center',
                veticalAlign: 'bottom'
              }
            }
          }]
        }
      }
    },
    chartInitItemsa () {
      var datas = this.chartsDatas.atmos.itemT1MaxDatas
      var dataKeys = this.itemDataKeysAtmos
      var xAxisData = ['SO2', 'NO2', 'CO*', 'O3', 'PM10', 'PM2o5']
      var xAxisList = []
      var seriesList = []
      for (var i = 0; i < dataKeys.length; i++) {
        if (datas[dataKeys[i] + 'T1Max']) {
          seriesList.push(datas[dataKeys[i] + 'T1Max'])
          xAxisList.push(xAxisData[i])
        }
      }
      var chartSeriesDatas = {
        xDates: { name: '时间', data: [] },
        xSO2: { name: 'SO2', data: [] },
        xNO2: { name: 'NO2', data: [] },
        xCO: { name: 'CO*', data: [] },
        xO3: { name: 'O3', data: [] },
        xPM10: { name: 'PM10', data: [] },
        xPM2o5: { name: 'PM2.5', data: [] }
      }
      for (var j = this.eqmAtmosData.length - 1; j > -1; j--) {
        chartSeriesDatas.xDates.data.push(this.eqmAtmosData[j].eqmTime)
        chartSeriesDatas.xSO2.data.push(this.eqmAtmosData[j].eqmaSO2)
        chartSeriesDatas.xNO2.data.push(this.eqmAtmosData[j].eqmaNO2)
        chartSeriesDatas.xCO.data.push(this.eqmAtmosData[j].eqmaCO)
        chartSeriesDatas.xO3.data.push(this.eqmAtmosData[j].eqmaO3)
        chartSeriesDatas.xPM10.data.push(this.eqmAtmosData[j].eqmaPM10)
        chartSeriesDatas.xPM2o5.data.push(this.eqmAtmosData[j].eqmaPM2o5)
      }
      // console.log('chartSeriesDatas', chartSeriesDatas)
      var chartSeries = []
      if (this.eqmAtmosAverage === 'hour') {
        chartSeries.push(
          chartSeriesDatas.xSO2,
          chartSeriesDatas.xNO2,
          chartSeriesDatas.xCO,
          chartSeriesDatas.xO3
        )
      } else if (this.eqmAtmosAverage === 'hours24') {
        chartSeries.push(
          chartSeriesDatas.xSO2,
          chartSeriesDatas.xNO2,
          chartSeriesDatas.xCO,
          chartSeriesDatas.xPM10,
          chartSeriesDatas.xPM2o5
        )
      }
      // console.log('chartSeries', chartSeries)
      this.chartOptionsItemsa = {
        title: {
          text: null
        },
        chart: {
          type: 'spline',
          backgroundColor: null
        },
        credits: {
          enabled: false
        },
        xAxis: {
          categories: chartSeriesDatas.xDates.data,
          labels: {
            style: {
              color: '#e0f0ff'
            }
          }
        },
        yAxis: {
          title: {
            text: ''
          },
          labels: {
            style: {
              color: '#e0f0ff'
            }
          },
          allowDecimals: true
        },
        series: chartSeries,
        tooltip: {
          enabled: true,
          valueDecimals: 1
          // valueSuffix: 'μg/m3'
        },
        legend: {
          enabled: true,
          layout: 'horizontal',
          align: 'center',
          verticalAlign: 'top',
          floating: false,
          // x: 100,
          y: -10,
          itemStyle: {
            color: '#e0f0ff'
          }
        },
        plotOptions: {
          series: {
            label: {
              connectorAllowed: false
            }
          }
        }
      }
    },
    chartInitItemsw () {
      var chartSeriesDatas = {
        xDates: { name: '时间', data: [] },
        xCODMn: { name: 'CODMn', data: [] },
        xCOD: { name: 'COD', data: [] },
        xBOD5: { name: 'BOD5', data: [] },
        xNH3_N: { name: 'NH3-H', data: [] }
      }
      for (var i = this.eqmWaterData.length - 1; i > -1; i--) {
        chartSeriesDatas.xDates.data.push(this.eqmWaterData[i].eqmTime)
        chartSeriesDatas.xCODMn.data.push(this.eqmWaterData[i].eqmwCODMn)
        chartSeriesDatas.xCOD.data.push(this.eqmWaterData[i].eqmwCOD)
        chartSeriesDatas.xBOD5.data.push(this.eqmWaterData[i].eqmwBOD5)
        chartSeriesDatas.xNH3_N.data.push(this.eqmWaterData[i].eqmwNH3_N)
      }
      // console.log('chartSeriesDatas', chartSeriesDatas)
      var chartSeries = [
        chartSeriesDatas.xCODMn,
        chartSeriesDatas.xCOD,
        chartSeriesDatas.xBOD5,
        chartSeriesDatas.xNH3_N
      ]
      // console.log('chartSeries', chartSeries)
      this.chartOptionsItemsw = {
        title: {
          text: null
        },
        chart: {
          type: 'spline',
          backgroundColor: null
        },
        credits: {
          enabled: false
        },
        xAxis: {
          categories: chartSeriesDatas.xDates.data,
          labels: {
            style: {
              color: '#e0f0ff'
            }
          }
        },
        yAxis: {
          title: {
            text: ''
          },
          labels: {
            style: {
              color: '#e0f0ff'
            }
          },
          allowDecimals: true
        },
        series: chartSeries,
        tooltip: {
          enabled: true,
          valueDecimals: 1
          // valueSuffix: 'μg/m3'
        },
        legend: {
          enabled: true,
          layout: 'horizontal',
          align: 'center',
          verticalAlign: 'top',
          floating: false,
          // x: 100,
          y: -10,
          itemStyle: {
            color: '#e0f0ff'
          }
        },
        plotOptions: {
          series: {
            label: {
              connectorAllowed: false
            }
          }
        }
      }
    },
    chartInit212a () {
      var datas = this.chartsDatas.atmos.itemT4SiteDatas
      var dataKeys = this.itemDataKeysAtmos
      var xAxisList = []
      var seriesList = []
      var seriesObjList = {
        xa1hSO2: { name: 'SO2', data: [] },
        xa1hNO2: { name: 'NO2', data: [] },
        xa1hCO: { name: 'CO*', data: [] },
        xa1hO3: { name: 'O3', data: [] },
        xa24hPM10: { name: 'PM10', data: [] },
        xa24hPM2o5: { name: 'PM2.5', data: [] }
      }
      for (var i = 0; i < datas.length; i++) {
        xAxisList.push(datas[i].xsiteName)
        for (var j = 0; j < dataKeys.length; j++) {
          seriesObjList[dataKeys[j]].data.push([datas[i].xsiteName, datas[i][dataKeys[j]]])
        }
      }
      for (var k in seriesObjList) {
        seriesList.push(seriesObjList[k])
      }
      console.log('seriesList', seriesList)
      this.chartOptions212a = {
        title: {
          text: null
        },
        chart: {
          type: 'scatter',
          zoomType: 'xy',
          backgroundColor: null
        },
        credits: {
          enabled: false
        },
        xAxis: {
          categories: xAxisList
          // labels: {
          //   style: {
          //     color: '#000'
          //   }
          // }
        },
        yAxis: {
          title: {
            text: ''
          },
          allowDecimals: true
        // },
        // tooltip: {
        //   enabled: true,
        //   valueDecimals: 1
        //   // valueSuffix: 'μg/m3'
        },
        legend: {
          enabled: true,
          layout: 'vertiacal',
          align: 'right',
          verticalAlign: 'top',
          floating: true,
          // x: 100,
          y: 20
          // borderWidth: 1,
          // backgroundColor: '#FFFFFF'
        },
        plotOptions: {
          scatter: {
            tooltip: {
              headerFormat: '<b>{series.name}</b><br>',
              pointFormat: '{point.y}'
            }
          }
        },
        series: seriesList,
        responsive: {
          rules: [{
            condition: {
              maxWidth: 480
            },
            chartOptions: {
              legend: {
                layout: 'horizontal',
                align: 'center',
                veticalAlign: 'bottom'
              }
            }
          }]
        }
      }
    },
    chartInit212w () {
      var datas = this.chartsDatas.water.itemT4SiteDatas
      var dataKeys = this.itemDataKeysWater
      var xAxisList = []
      var seriesList = []
      var seriesObjList = {
        xwCODMn: { name: 'CODMn', data: [] },
        xwCOD: { name: 'COD', data: [] },
        xwBOD5: { name: 'BOD5', data: [] },
        xwNH3_H: { name: 'NH3-H', data: [] }
      }
      for (var i = 0; i < datas.length; i++) {
        xAxisList.push(datas[i].xsiteName)
        for (var j = 0; j < dataKeys.length; j++) {
          seriesObjList[dataKeys[j]].data.push([datas[i].xsiteName, datas[i][dataKeys[j]]])
        }
      }
      for (var k in seriesObjList) {
        seriesList.push(seriesObjList[k])
      }
      console.log('seriesList', seriesList)
      this.chartOptions212w = {
        title: {
          text: null
        },
        chart: {
          type: 'scatter',
          zoomType: 'xy',
          backgroundColor: null
        },
        credits: {
          enabled: false
        },
        xAxis: {
          categories: xAxisList
        },
        yAxis: {
          title: {
            text: ''
          },
          allowDecimals: true
        // },
        // tooltip: {
        //   enabled: true,
        //   valueDecimals: 1
        //   // valueSuffix: 'μg/m3'
        },
        legend: {
          enabled: true,
          layout: 'vertiacal',
          align: 'right',
          verticalAlign: 'top',
          floating: true,
          // x: 100,
          y: 20
          // borderWidth: 1,
          // backgroundColor: '#FFFFFF'
        },
        plotOptions: {
          scatter: {
            tooltip: {
              headerFormat: '<b>{series.name}</b><br>',
              pointFormat: '{point.y}'
            }
          }
        },
        series: seriesList,
        responsive: {
          rules: [{
            condition: {
              maxWidth: 480
            },
            chartOptions: {
              legend: {
                layout: 'horizontal',
                align: 'center',
                veticalAlign: 'bottom'
              }
            }
          }]
        }
      }
    },
    chartInit221a () {
      var datas = this.chartsDatas.atmos.itemMaxDatas
      var dataKeys = this.itemDataKeysAtmos
      var seriesList = []
      for (var i = 0; i < dataKeys.length; i++) {
        seriesList.push(datas[dataKeys[i] + 'Max'])
      }
      this.chartOptions221a = {
        title: {
          text: null
        },
        chart: {
          type: 'column',
          backgroundColor: null
        },
        credits: {
          enabled: false
        },
        xAxis: {
          categories: ['SO2', 'NO2', 'CO*', 'O3', 'PM10', 'PM2.5']
        },
        yAxis: {
          title: {
            text: ''
          },
          allowDecimals: true
        },
        tooltip: {
          enabled: true,
          valueDecimals: 1
          // valueSuffix: 'μg/m3'
        },
        legend: {
          enabled: false,
          layout: 'vertiacal',
          align: 'right',
          verticalAlign: 'right'
        },
        plotOptions: {
          column: {
            stacking: 'normal',
            dataLabels: {
              enabled: true,
              inside: false,
              color: this.color[4]
            }
          },
          series: {
            label: {
              connectorAllowed: false
            }
          }
        },
        series: [{
          name: 'max',
          data: seriesList,
          color: this.color[4]
        }],
        responsive: {
          rules: [{
            condition: {
              maxWidth: 480
            },
            chartOptions: {
              legend: {
                layout: 'horizontal',
                align: 'center',
                veticalAlign: 'bottom'
              }
            }
          }]
        }
      }
    },
    chartInit221w () {
      var datas = this.chartsDatas.water.itemMaxDatas
      var dataKeys = this.itemDataKeysWater
      var seriesList = []
      for (var i = 0; i < dataKeys.length; i++) {
        seriesList.push(datas[dataKeys[i] + 'Max'])
      }
      this.chartOptions221w = {
        title: {
          text: null
        },
        chart: {
          type: 'column',
          backgroundColor: null
        },
        credits: {
          enabled: false
        },
        xAxis: {
          categories: ['CODMn', 'COD', 'BOD5', 'NH3-H']
        },
        yAxis: {
          title: {
            text: ''
          },
          allowDecimals: true
        },
        tooltip: {
          enabled: true,
          valueDecimals: 1,
          valueSuffix: 'mg/L'
        },
        legend: {
          enabled: false,
          layout: 'vertiacal',
          align: 'right',
          verticalAlign: 'right'
        },
        plotOptions: {
          series: {
            label: {
              connectorAllowed: false
            },
            dataLabels: {
              enabled: true,
              inside: false,
              color: this.color[4]
            }
          }
        },
        series: [{
          name: 'max',
          data: seriesList,
          color: this.color[4]
        }],
        responsive: {
          rules: [{
            condition: {
              maxWidth: 480
            },
            chartOptions: {
              legend: {
                layout: 'horizontal',
                align: 'center',
                veticalAlign: 'bottom'
              }
            }
          }]
        }
      }
    },
    chartInitT2Bara () {
      var datas = this.chartsDatas.atmos.itemT1MaxDatas
      var dataKeys = this.itemDataKeysAtmos
      var xAxisData = ['SO2', 'NO2', 'CO*', 'O3', 'PM10', 'PM2o5']
      var xAxisList = []
      var seriesList = []
      for (var i = 0; i < dataKeys.length; i++) {
        if (datas[dataKeys[i] + 'T1Max']) {
          seriesList.push(datas[dataKeys[i] + 'T1Max'])
          xAxisList.push(xAxisData[i])
        }
      }
      this.chartOptionsT2Bara = {
        title: {
          text: null
        },
        chart: {
          type: 'bar',
          backgroundColor: null
        },
        credits: {
          enabled: false
        },
        xAxis: {
          categories: xAxisList
        },
        yAxis: {
          title: {
            text: ''
          },
          allowDecimals: true
        },
        tooltip: {
          enabled: true,
          valueDecimals: 1
          // valueSuffix: 'μg/m3'
        },
        legend: {
          enabled: false,
          layout: 'vertiacal',
          align: 'right',
          verticalAlign: 'right'
        },
        plotOptions: {
          bar: {
            stacking: 'normal',
            dataLabels: {
              enabled: true,
              inside: false,
              color: this.color[0]
            }
          },
          series: {
            label: {
              connectorAllowed: false
            }
          }
        },
        series: [{
          name: 'max',
          data: seriesList,
          color: this.color[0]
        }],
        responsive: {
          rules: [{
            condition: {
              maxWidth: 480
            },
            chartOptions: {
              legend: {
                layout: 'horizontal',
                align: 'center',
                veticalAlign: 'bottom'
              }
            }
          }]
        }
      }
    },
    chartInitT2Barw () {
      var datas = this.chartsDatas.water.itemT1MaxDatas
      var dataKeys = this.itemDataKeysWater
      var xAxisData = ['CODMn', 'COD', 'BOD5', 'NH3-H']
      var xAxisList = []
      var seriesList = []
      for (var i = 0; i < dataKeys.length; i++) {
        if (datas[dataKeys[i] + 'T1Max']) {
          seriesList.push(datas[dataKeys[i] + 'T1Max'])
          xAxisList.push(xAxisData[i])
        }
      }
      this.chartOptionsT2Barw = {
        title: {
          text: null
        },
        chart: {
          type: 'bar',
          backgroundColor: null
        },
        credits: {
          enabled: false
        },
        xAxis: {
          categories: xAxisList
        },
        yAxis: {
          title: {
            text: ''
          },
          allowDecimals: true
        },
        tooltip: {
          enabled: true,
          valueDecimals: 1,
          valueSuffix: 'mg/L'
        },
        legend: {
          enabled: false,
          layout: 'vertiacal',
          align: 'right',
          verticalAlign: 'right'
        },
        plotOptions: {
          bar: {
            stacking: 'normal',
            dataLabels: {
              enabled: true,
              inside: false,
              color: this.color[0]
            }
          },
          series: {
            label: {
              connectorAllowed: false
            }
          }
        },
        series: [{
          name: 'max',
          data: seriesList,
          color: this.color[0]
        }],
        responsive: {
          rules: [{
            condition: {
              maxWidth: 480
            },
            chartOptions: {
              legend: {
                layout: 'horizontal',
                align: 'center',
                veticalAlign: 'bottom'
              }
            }
          }]
        }
      }
    },
    clearMap () {
      clearInterval(this.autoRefreshCcltr)
      this.player = null
      clearInterval(this.hpSLt5BoxCcltor)
      clearInterval(this.hpSLt2BoxCcltor)
      clearInterval(this.hpSLt3BoxCcltor)
      clearInterval(this.hpSLt4BoxCcltor)
    }
  },
  beforeDestroy () {
    this.clearMap()
    console.log('beforeDestroy')
  },
  watch: {
    '$route' (to, from) { // 检测路由地址变化
      console.log(`watchRouteLeaveFrom${from.path}To${to.path}xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxy`)
      if (to.path !== '/ehsHome') {
        this.clearMap()
        var that = this
        that.$destroy()
        console.log(`watchRouteLeaveFrom${from.path}To${to.path}yyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyy`)
        // console.log('watchRouteLeaveTo')
      }
    },
    windowClientHeight (newValue, oldValue) {
      console.log(this.windowClientHeight)
      this.$nextTick(() => {
        this.initSLCcltor()
        console.log(this.hpSLt5BoxCcltor, this.hpSLt2BoxCcltor, this.hpSLt3BoxCcltor, this.hpSLt4BoxCcltor)
      })
    }
  },
  // beforeRouteEnter () {
  //   console.log('beforeRouteEnter')
  //   this.autoRefresh()
  //   this.getHomeDatas()
  //   this.mapinit()
  //   this.getCpnInfo()
  // },
  components: {
    // api
    ehsEQMAtmos,
    ehsEQMWater
    // axios
  }
}
</script>

<style lang="scss">
.ehsmapwrap{
  z-index: 0;
  // height: 100vh;
  height: 100%;
  overflow: hidden;
  margin: 0!important;
  // padding: 0 0 0 8px!important;
  // width: calc(100% - 10px);
  background-image: linear-gradient(#000f1f, #003f7f);
  .ehsRollingTitle{
    color: #007fff;
    position: relative;
    width: 100%;
    height: 50px;
    border-top: 4px solid #007fff;
    border-bottom: 4px solid #007fff;
    margin: 5px 0;
    line-height: 50px;
    overflow: hidden;
    text-align: center;
    z-index: 100;
    .r-block{
      display: inline-block;
      width: 100%;
      height: 100%;
      vertical-align: middle;
      overflow: hidden;
      box-sizing: border-box;
      position: relative;
      font-size: 36px;
      font-weight: bolder;
      font-family: 'Times New Roman', 'SimHei', Georgia, Times, serif;
    }
    .r-text1 {
      animation: r-text1 30s linear infinite;
      white-space: nowrap;
      position: absolute;
    }
    .r-text2 {
      animation: r-text2 30s linear infinite;
      white-space: nowrap;
      position: absolute;
    }
    @keyframes r-text1 {
      0% { left: 0; }
      100% { left: -100%;}
    }
    @keyframes r-text2 {
      0% { left: 100%; }
      100% { left: 0; }
    }
    // .remind-block span{
    //   // border-bottom: 1px solid #947334;
    //   font-weight:bold;
    // }
    // .remind-block img{
    //   height: 20px;
    //   position: absolute;
    //   right: 2px;
    //   top: 5px;
    // }
  }
  .container{
    height: calc(100% - 60px)!important;
    font-family: 'Times New Roman', 'SimHei', Georgia, Times, serif;
    .highcharts-container{
      border: none;
    }
    .headerhtt{
      padding: 0!important;
    }
    .subcon{
      height: 70%!important;
      width: 100%;
      display: flex;
      .asideL{
        width: 25%!important;
        overflow: visible;
        height: 100%;
        .hp2divspie{
          margin: 0 2px 4px 2px;
          height: calc(50% - 4px);
          width: calc(100% - 4px);
          .piesubdivs{
            height: 100%;
            width: 100%;
            .piesubdivsheader{
              height: 40px;
              line-height: 40px;
              font-size: 16px;
              width: 100%;
              text-align: center;
              background-image: linear-gradient(#003f7f, #001f3f);
              color: #e0f0ff;
            }
            .part2charts{
              height: calc(100% - 40px);
              width: 100%;
              background-image: linear-gradient(#001f3f, #002f5f);
              // background-color: lightcyan;
            }
          }
        }
        .hpEqmChartDiv{
          margin: 0 2px 2px 2px;
          height: calc(50% - 2px);
          width: calc(100% - 4px);
          .eqmChartItems{
            height: 100%;
            // margin: 0 2%;
            width: 100%;
            .eqmChartItemsheader{
              height: 40px;
              line-height: 40px;
              font-size: 16px;
              width: 100%;
              text-align: center;
              background-image: linear-gradient(#003f7f, #001f3f);
              color: #e0f0ff;
            }
            .part2charts{
              height: calc(100% - 40px);
              width: 100%;
              background-image: linear-gradient(#001f3f, #002f5f);
            }
          }
        }
      }
      .mainDiv{
        width: calc(50% - 4px);
        .headerhtt{
          background-color: white;
          height: 40px!important;
          padding: 4px 0 -10px!important;
          margin: 0 2px;
          width: calc(100% - 4px);
          .el-tabs__item{
            font-size: 24px;
            font-weight: bold;
            font-family: 'Times New Roman', 'SimHei', Georgia, Times, serif;
            // border: 2px solid #005fbf;
            // border-top: 2px solid #006fDf;
            // border-bottom: 2px solid #006fDf;
            // border-radius: 50% 50% 0 0 / 30px 30px 0 0;
            transition: 0.2s all;
            color: #007fff;
            line-height: 38px;
            background-image: linear-gradient(#003f7f, #001f3f);
          }
          .is-active{
            // border-top: 2px solid #006fDf;
            // border-bottom: 2px solid #006fDf;
            background-image: linear-gradient(#003f7f, #001f3f);
            color: #e0f0ff;
            transition: 0.2s all;
          }
          .el-tabs__active-bar{
            display: none;
          }
          .httTab{
            // background-color: lightblue;
            .el-tabs__item{
              padding: 0;
            }
          }
        }
        .mainMap{
          padding: 0;
          margin: 0 2px 2px 2px;
          height: calc(100% - 40px - 2px);
          width: calc(100% - 4px);
          background: #c0dfff;
          .arcgis-map-div{
            // display: flex;
            height: 100%;
            width: 100%;
            .arcgis-map{
              height: 100%;
              width: 100%;
              // border: 4px solid #008888;
              .esri-view-root{
                .esri-ui{
                  .esri-ui-inner-container{
                    .esri-ui-top-left{
                      // .esri-search{
                      //   margin-bottom: -32px;
                      //   margin-left : 42px;
                      // }
                      .esri-navigation-toggle{
                        margin-top: -74px;
                        margin-left: 42px;
                      }
                    }
                    .esri-ui-bottom-left{
                      .esri-time-slider{
                        width: 40%;
                        .esri-time-slider__row{
                          height: 32px;
                          .esri-time-slider__animation,
                          .esri-time-slider__previous,
                          .esri-time-slider__next{
                            width: 32px;
                          }
                          .esri-time-slider__time-extent{
                            width: 160px;
                          }
                          .esri-time-slider__min,
                          .esri-time-slider__max{
                            width: 0;
                          }
                          .esri-time-slider__slider{
                            padding: 6px 16px;
                            .esri-slider{
                              margin: 0;
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
      .asideR{
        width: 25%!important;
        overflow: hidden;
        // margin-top: -40px;
        height: 100%;
        .hpMntDiv{
          margin: 0 2px 4px 2px;
          height: calc(50% - 4px);
          width: calc(100% - 4px);
          .hpMntDivHeader{
            height: 40px;
            line-height: 40px;
            font-size: 16px;
            width: 100%;
            text-align: center;
            background-image: linear-gradient(#003f7f, #001f3f);
            // background-color: #808080;
            color: rgb(243, 243, 243);
            border-top: 1px solid #003f7f;
            border-right: 1px solid #003f7f;
            border-left: 1px solid #003f7f;
          }
          .markerVideoPlayer{
            width: 100%;
            height: calc(100% - 40px);
            background-image: linear-gradient(#001f3f, #002f5f);
            line-height: calc(100% - 40px);
            .myMntVideoUdf{
              width: 100%;
              font-size: 14px;
              text-align: center;
              height: 36px;
              font-weight: bold;
              line-height: 36px;
              background-color: #ccc;
            }
            .no-video{
              display: flex;
              height: 100%;
              font-size: 14px;
              text-align: center;
              justify-content: center;
              align-items: center;
            }
            .myMntVideo {
              height: 100%;
              object-fit: contain;
              width: 100%;
              margin-bottom: 0;
            }
            ::-webkit-scrollbar{
              display: none;
            }
          }
        }
        .hpCpmInfoList{
          margin: 0 2px 2px 2px;
          height: calc(50% - 2px);
          width: calc(100% - 4px);
          .hpCpnInfoHead{
            height: 40px;
            line-height: 40px;
            font-size: 19px;
            width: 100%;
            text-align: center;
            background-image: linear-gradient(#003f7f, #001f3f);
            color: #c0dfff;
            display: flex;
            .hpCpnInfoHeadName{
              width: calc(100% - 84px);
              line-height: 40px;
              // padding: 2px;
            }
            .hpCpnInfoHeadIdVal{
              width: 84px;
              line-height: 40px;
              // padding: 2px;
            }
          }
          .hpCpnInfoMain::-webkit-scrollbar{
            display: none;
          }
          .hpCpnInfoMain{
            width: 100%!important;
            height: calc(100% - 40px)!important;
            overflow: auto;
            .hpCpnInfoItem{
              width: 100%!important;
              height: 30px!important;
              // border: 1px solid #003f7f;
              .hpCpnInfoData{
                width: 100%;
                display: flex;
                text-align: center;
                .hpCpnInfoName{
                  width: calc(100% - 84px);
                  line-height: 24px;
                  font-size: 15px;
                  padding: 2px;
                }
                .hpCpnInfoIdVal{
                  width: calc(84px);
                  line-height: 24px;
                  font-size: 15px;
                  padding: 2px;
                }
              }
            }
            .cpnStripes{
              background-image: linear-gradient(#003f7f, #002f5f);
            }
          }
        }
        .bc{
          color: #c0dfff;
          background-image: linear-gradient(#001f3f, #002f5f);
        }
      }
    }
    .footersites{
      height: calc(30vh - 30px)!important;
      padding: 0!important;
      display: flex;
      overflow: hidden;
      .hpSiteListDivs{
        height: 100%!important;
        width: 25%;
        padding: 2px!important;
        .hpSiteListCard{
          height: 100%!important;
          background-image: linear-gradient(#001f3f, #002f5f);
          .hpSiteListHead{
            // margin: 0px;
            font-size: 18px;
            text-align: center;
            // color: rgb(243, 243, 243);
            // font-weight: bold;
            width: 100%!important;
            height: 40px;
            .hpSiteListhdiv{
              padding: 6px 0;
            }
          }
          .hpSiteListMain::-webkit-scrollbar{
            display: none;
          }
          .hpSiteListMain{
            width: 100%!important;
            height: calc(100% - 40px)!important;
            overflow: auto;
            // border-left: 1px solid #c0dfff;
            // border-right: 1px solid #c0dfff;
            // border-bottom: 1px solid #c0dfff;
            .hpSiteListItem{
              width: 100%!important;
              height: 30px!important;
              // border: 1px solid #003f7f;
              .hpSiteListData{
                width: calc(100% - 10px);
                margin: 0 5px 4px;
                display: flex;
                .hpSiteListName{
                  flex: 1;
                  width: 50%;
                  line-height: 24px;
                  font-size: 15px;
                  padding: 2px;
                }
                .hpSiteListIdVal{
                  flex: 1;
                  width: 50%;
                  line-height: 24px;
                  font-size: 15px;
                  text-align: right;
                  padding: 2px;
                }
              }
            }
            .t2Stripes, .t3Stripes, .t4Stripes{
              background-image: linear-gradient(#003f7f, #002f5f);
            }
            // .anm-1{
            //   animation: anm-1 2s linear infinite;
            //   position: relative;
            // }
            // @keyframes anm-1 {
            //   0% { top: 0; }
            //   100% { top: -50%;}
            // }
            // .anm-2{
            //   animation: anm-2 5s linear infinite;
            //   position: relative;
            // }
            // @keyframes anm-2 {
            //   0% { top: 50%; }
            //   100% { top: 0;}
            // }
          }
        }
        .t2bc{
          color: #39e239;
        }
        .t3bc{
          color: #ffe4a0;
        }
        .t4bc{
          color: #ff6666;
        }
        #hpSLHT2, #hpSLHT3, #hpSLHT4{
          background-image: linear-gradient(#003f7f, #001f3f);
        }
        .t1subdivs{
          height: 100%;
          .t1subdivsheader{
            height: 40px;
            line-height: 40px;
            font-size: 16px;
            width: 100%;
            text-align: center;
            background-image: linear-gradient(#003f7f, #001f3f);
            color: #c0dfff;
          }
          .t1charts{
            height: calc(100% - 40px);
            width: 100%;
            background-image: linear-gradient(#001f3f, #002f5f);
          }
        }
      }
      .tips{
        padding: 4px;
        color: #e0f0ff;
      }
      .fullscreenBtn{
        text-align: right;
        padding: 4px;
        .el-button{
          font-size: 12px;
          height: 24px;
          width: 24px;
          padding: 4px;
          line-height: 16px;
        }
      }
    }
  }
  .esri-sketch{
    font-size: 16px!important;
    margin-right: 44px;
    margin-top: -74px;
    .esri-sketch__section{
      padding: 0;
      margin: 0;
      // height: 32px!important;
      // calcite-action{
      //   font-size: 16px!important;
      //   width: 32px!important;
      //   height: 32px!important;
      //   // overflow: hidden;
      //   padding: 0;
      //   button{
      //     width: 16px!important;
      //     height: 16px!important;
      //   }
      // }
    }
  }
  .measurementBar{
    background: #fff;
    .action-button {
      font-size: 16px;
      background-color: transparent;
      border: 0 solid #d3d3d3;
      color: #6e6e6e;
      height: 32px;
      width: 32px;
      text-align: center;
      box-shadow: 0 0 1px rgba(0, 0, 0, 0.3);
    }
    .action-button:hover,
    .action-button:focus {
      background: #007fff;
      color: #e4e4e4;
    }
    .action-button.active {
      background: #007fff;
      color: #e4e4e4;
    }
  }
  .provinceList{
    width: 160px;
    select{
      width: 100%;
      height: 32px;
      padding: 4px;
      font-size: 16px;
    }
    .el-input{
      .el-input__inner{
        height: 32px!important;
        font-size: 16px;
        border-radius: 0!important;
        text-align: center;
        padding: 0;
      }
      .el-input__suffix{
        display: none;
      }
    }
  }
  .homepage{
    width: 100%;
    div{
      border-radius: 2px;
    }
  }
  .div{
    margin-top: 0px;
    .div__header{
      padding: 0;
    }
    .div__body{
      padding: 0;
      overflow-y: auto;
    }
  }
  .choose-btn-pc {
    border: 1px solid #ccc;
    padding: 0 24px;
    display: flex;
    flex-wrap: wrap;
    text-align: center!important;
    span {
      background: #f3f3f3;
      border-radius: 4px;
      margin: 4px 4px;
      &:hover {
        cursor: pointer;
      }
      &.active {
        background: #007AFF;
        color: #fff;
      }
    }
  }
  .nut-textinput-label {
    text-align: left;
    width: 58px;
  }
}
</style>
